const AllGeneListMatch = {
    "AATF": [
        "AATF_58K"
    ],
    "ABCE1": [
        "ABCE1_181K"
    ],
    "ABCF1": [
        "ABCF1_430K",
        "ABCF1_163K"
    ],
    "ABCF2": [
        "ABCF2_351K",
        "ABCF2_618K"
    ],
    "ABCF3": [
        "ABCF3_457K"
    ],
    "ACADVL": [
        "ACADVL_276K"
    ],
    "ACAT1": [
        "ACAT1_268K"
    ],
    "ACIN1": [
        "ACIN1_818K",
        "ACIN1_823K",
        "ACIN1_970K",
        "ACIN1_103K",
        "ACIN1_986K"
    ],
    "ACLY": [
        "ACLY_4K"
    ],
    "ACO2": [
        "ACO2_401K"
    ],
    "ACSF2": [
        "ACSF2_340K",
        "ACSF2_510K"
    ],
    "ACTG1": [
        "ACTG1_61K",
        "ACTG1_326K",
        "ACTG1_328K",
        "ACTG1_50K",
        "ACTG1_315K",
        "ACTG1_113K"
    ],
    "ACTN1": [
        "ACTN1_103K",
        "ACTN1_436K"
    ],
    "ACTN4": [
        "ACTN4_632K"
    ],
    "ACTR2": [
        "ACTR2_46K"
    ],
    "ADAT1": [
        "ADAT1_422K"
    ],
    "ADIRF": [
        "ADIRF_70K"
    ],
    "ADK": [
        "ADK_11K",
        "ADK_14K"
    ],
    "ADNP": [
        "ADNP_606K",
        "ADNP_616K",
        "ADNP_1048K",
        "ADNP_658K",
        "ADNP_144K",
        "ADNP_716K",
        "ADNP_148K",
        "ADNP_1035K",
        "ADNP_266K",
        "ADNP_278K",
        "ADNP_600K",
        "ADNP_1029K"
    ],
    "AGFG1": [
        "AGFG1_318K"
    ],
    "AGR2": [
        "AGR2_95K"
    ],
    "AHCTF1": [
        "AHCTF1_2237K",
        "AHCTF1_2258K"
    ],
    "AHCY": [
        "AHCY_389K",
        "AHCY_188K"
    ],
    "AHNAK": [
        "AHNAK_2578K",
        "AHNAK_1652K",
        "AHNAK_1322K",
        "AHNAK_4985K",
        "AHNAK_5831K",
        "AHNAK_5833K",
        "AHNAK_5103K",
        "AHNAK_4118K",
        "AHNAK_4125K",
        "AHNAK_1911K",
        "AHNAK_1918K",
        "AHNAK_1184K",
        "AHNAK_807K",
        "AHNAK_1568K",
        "AHNAK_3363K",
        "AHNAK_5772K",
        "AHNAK_2603K",
        "AHNAK_5740K",
        "AHNAK_5725K",
        "AHNAK_748K",
        "AHNAK_5443K",
        "AHNAK_5665K",
        "AHNAK_1205K",
        "AHNAK_3303K",
        "AHNAK_128K",
        "AHNAK_4979K",
        "AHNAK_563K",
        "AHNAK_5821K",
        "AHNAK_2568K",
        "AHNAK_134K",
        "AHNAK_1594K",
        "AHNAK_1408K",
        "AHNAK_3356K",
        "AHNAK_5858K",
        "AHNAK_1466K",
        "AHNAK_4845K",
        "AHNAK_1319K",
        "AHNAK_942K",
        "AHNAK_5716K",
        "AHNAK_884K",
        "AHNAK_1005K",
        "AHNAK_756K",
        "AHNAK_5027K",
        "AHNAK_2773K",
        "AHNAK_1773K",
        "AHNAK_1194K",
        "AHNAK_1177K",
        "AHNAK_1870K",
        "AHNAK_3106K",
        "AHNAK_2978K",
        "AHNAK_2132K",
        "AHNAK_1210K",
        "AHNAK_961K",
        "AHNAK_712K",
        "AHNAK_489K",
        "AHNAK_1360K",
        "AHNAK_855K",
        "AHNAK_313K",
        "AHNAK_438K",
        "AHNAK_341K"
    ],
    "AHNAK2": [
        "AHNAK2_839K",
        "AHNAK2_5701K",
        "AHNAK2_1255K"
    ],
    "AHSA1": [
        "AHSA1_194K",
        "AHSA1_203K"
    ],
    "AIF1L": [
        "AIF1L_13K"
    ],
    "AIP": [
        "AIP_112K"
    ],
    "AKAP8": [
        "AKAP8_306K"
    ],
    "AKAP8L": [
        "AKAP8L_533K"
    ],
    "AKR1D1": [
        "AKR1D1_71K"
    ],
    "ALDOA": [
        "ALDOA_330K",
        "ALDOA_99K",
        "ALDOA_101K",
        "ALDOA_312K",
        "ALDOA_147K",
        "ALDOA_322K",
        "ALDOA_108K",
        "ALDOA_42K",
        "ALDOA_28K",
        "ALDOA_14K",
        "ALDOA_13K"
    ],
    "ALDOC": [
        "ALDOC_42K"
    ],
    "ALKBH5": [
        "ALKBH5_323K"
    ],
    "ALYREF": [
        "ALYREF_81K"
    ],
    "ANKRD26": [
        "ANKRD26_1334K"
    ],
    "ANLN": [
        "ANLN_148K"
    ],
    "ANP32A": [
        "ANP32A_238K"
    ],
    "ANP32E": [
        "ANP32E_6K"
    ],
    "ANXA2": [
        "ANXA2_47K",
        "ANXA2_204K",
        "ANXA2_152K",
        "ANXA2_302K",
        "ANXA2_115K"
    ],
    "ANXA3": [
        "ANXA3_154K"
    ],
    "ANXA5": [
        "ANXA5_76K"
    ],
    "AP2B1": [
        "AP2B1_12K"
    ],
    "APBB1IP": [
        "APBB1IP_344K"
    ],
    "APEX1": [
        "APEX1_7K"
    ],
    "API5": [
        "API5_398K",
        "API5_448K"
    ],
    "AQR": [
        "AQR_762K"
    ],
    "ARCN1": [
        "ARCN1_233K",
        "ARCN1_224K"
    ],
    "ARFGAP1": [
        "ARFGAP1_285K"
    ],
    "ARGLU1": [
        "ARGLU1_253K",
        "ARGLU1_264K"
    ],
    "ARHGAP5": [
        "ARHGAP5_709K"
    ],
    "ARHGEF2": [
        "ARHGEF2_360K"
    ],
    "ARID3A": [
        "ARID3A_176K"
    ],
    "ARL14EP": [
        "ARL14EP_177K",
        "ARL14EP_83K"
    ],
    "ARL3": [
        "ARL3_11K"
    ],
    "ARL6IP5": [
        "ARL6IP5_151K"
    ],
    "ARMC1": [
        "ARMC1_130K"
    ],
    "ARMT1": [
        "ARMT1_40K"
    ],
    "ARPC1B": [
        "ARPC1B_307K"
    ],
    "ARPC2": [
        "ARPC2_295K"
    ],
    "ARPC4": [
        "ARPC4_44K"
    ],
    "ARPC5": [
        "ARPC5_13K",
        "ARPC5_67K",
        "ARPC5_3K"
    ],
    "ARPIN": [
        "ARPIN_90K"
    ],
    "ARPP19": [
        "ARPP19_75K"
    ],
    "ASNS": [
        "ASNS_556K"
    ],
    "ASPM": [
        "ASPM_3404K"
    ],
    "ASPSCR1": [
        "ASPSCR1_360K",
        "ASPSCR1_271K",
        "ASPSCR1_268K",
        "ASPSCR1_286K"
    ],
    "ATAD3A": [
        "ATAD3A_472K"
    ],
    "ATF1": [
        "ATF1_69K"
    ],
    "ATG7": [
        "ATG7_309K"
    ],
    "ATIC": [
        "ATIC_406K"
    ],
    "ATOX1": [
        "ATOX1_25K"
    ],
    "ATP5F1A": [
        "ATP5F1A_531K",
        "ATP5F1A_539K",
        "ATP5F1A_427K",
        "ATP5F1A_498K",
        "ATP5F1A_261K",
        "ATP5F1A_175K",
        "ATP5F1A_161K"
    ],
    "ATP5F1B": [
        "ATP5F1B_522K",
        "ATP5F1B_201K",
        "ATP5F1B_124K",
        "ATP5F1B_133K",
        "ATP5F1B_426K",
        "ATP5F1B_198K"
    ],
    "ATP5F1C": [
        "ATP5F1C_55K",
        "ATP5F1C_39K"
    ],
    "ATP5PB": [
        "ATP5PB_162K"
    ],
    "ATP6V1B2": [
        "ATP6V1B2_109K"
    ],
    "ATRIP": [
        "ATRIP_32K"
    ],
    "ATRX": [
        "ATRX_433K",
        "ATRX_438K",
        "ATRX_299K",
        "ATRX_956K",
        "ATRX_568K",
        "ATRX_307K",
        "ATRX_768K",
        "ATRX_660K",
        "ATRX_584K"
    ],
    "ATXN1": [
        "ATXN1_350K",
        "ATXN1_712K",
        "ATXN1_346K"
    ],
    "ATXN2L": [
        "ATXN2L_348K"
    ],
    "ATXN3": [
        "ATXN3_206K"
    ],
    "BAG1": [
        "BAG1_221K"
    ],
    "BAG3": [
        "BAG3_344K"
    ],
    "BAP18": [
        "BAP18_77K"
    ],
    "BAZ1A": [
        "BAZ1A_1277K"
    ],
    "BAZ1B": [
        "BAZ1B_352K"
    ],
    "BAZ2A": [
        "BAZ2A_1786K"
    ],
    "BBX": [
        "BBX_831K"
    ],
    "BCAP31": [
        "BCAP31_167K",
        "BCAP31_192K",
        "BCAP31_199K"
    ],
    "BCAS2": [
        "BCAS2_177K"
    ],
    "BCCIP": [
        "BCCIP_231K"
    ],
    "BCL9L": [
        "BCL9L_108K"
    ],
    "BCLAF1": [
        "BCLAF1_457K",
        "BCLAF1_536K",
        "BCLAF1_413K",
        "BCLAF1_462K",
        "BCLAF1_437K",
        "BCLAF1_886K",
        "BCLAF1_332K",
        "BCLAF1_445K"
    ],
    "BEND3": [
        "BEND3_129K"
    ],
    "BIN1": [
        "BIN1_13K",
        "BIN1_164K"
    ],
    "BIRC6": [
        "BIRC6_2265K"
    ],
    "BMS1": [
        "BMS1_1172K"
    ],
    "BOD1L1": [
        "BOD1L1_2910K"
    ],
    "BOLA2": [
        "BOLA2_47K"
    ],
    "BPTF": [
        "BPTF_791K",
        "BPTF_786K"
    ],
    "BRD3": [
        "BRD3_245K",
        "BRD3_683K"
    ],
    "BRD4": [
        "BRD4_1242K",
        "BRD4_1114K",
        "BRD4_694K"
    ],
    "BRIP1": [
        "BRIP1_954K",
        "BRIP1_575K",
        "BRIP1_1242K",
        "BRIP1_137K"
    ],
    "BRIX1": [
        "BRIX1_17K"
    ],
    "BRMS1L": [
        "BRMS1L_249K",
        "BRMS1L_307K"
    ],
    "BRPF1": [
        "BRPF1_983K"
    ],
    "BTAF1": [
        "BTAF1_248K"
    ],
    "BTF3": [
        "BTF3_54K",
        "BTF3_57K",
        "BTF3_171K"
    ],
    "BZW1": [
        "BZW1_390K",
        "BZW1_5K",
        "BZW1_8K"
    ],
    "BZW2": [
        "BZW2_6K"
    ],
    "C11orf98": [
        "C11orf98_7K"
    ],
    "C18orf25": [
        "C18orf25_155K"
    ],
    "C19orf53": [
        "C19orf53_60K",
        "C19orf53_51K",
        "C19orf53_48K"
    ],
    "C20orf27": [
        "C20orf27_6K"
    ],
    "C2orf49": [
        "C2orf49_201K"
    ],
    "C5orf24": [
        "C5orf24_114K"
    ],
    "C7orf50": [
        "C7orf50_21K",
        "C7orf50_14K"
    ],
    "C9orf78": [
        "C9orf78_281K",
        "C9orf78_185K",
        "C9orf78_127K",
        "C9orf78_30K",
        "C9orf78_204K"
    ],
    "CACYBP": [
        "CACYBP_212K",
        "CACYBP_19K"
    ],
    "CAD": [
        "CAD_1411K"
    ],
    "CALD1": [
        "CALD1_655K",
        "CALD1_640K",
        "CALD1_534K",
        "CALD1_739K",
        "CALD1_486K",
        "CALD1_635K",
        "CALD1_577K",
        "CALD1_781K"
    ],
    "CALM3": [
        "CALM3_78K"
    ],
    "CALR": [
        "CALR_64K",
        "CALR_153K",
        "CALR_159K"
    ],
    "CAMK2D": [
        "CAMK2D_318K",
        "CAMK2D_322K"
    ],
    "CAMK2G": [
        "CAMK2G_318K"
    ],
    "CAND1": [
        "CAND1_577K"
    ],
    "CANX": [
        "CANX_170K",
        "CANX_210K",
        "CANX_217K"
    ],
    "CAP1": [
        "CAP1_317K",
        "CAP1_287K",
        "CAP1_282K"
    ],
    "CAPRIN1": [
        "CAPRIN1_223K"
    ],
    "CAPZA1": [
        "CAPZA1_278K"
    ],
    "CAPZB": [
        "CAPZB_235K"
    ],
    "CASP7": [
        "CASP7_38K"
    ],
    "CAST": [
        "CAST_43K"
    ],
    "CASZ1": [
        "CASZ1_311K",
        "CASZ1_238K",
        "CASZ1_37K"
    ],
    "CBFB": [
        "CBFB_177K"
    ],
    "CBLL1": [
        "CBLL1_33K"
    ],
    "CBX1": [
        "CBX1_103K"
    ],
    "CBX3": [
        "CBX3_5K",
        "CBX3_10K",
        "CBX3_92K",
        "CBX3_103K",
        "CBX3_21K"
    ],
    "CBX5": [
        "CBX5_91K",
        "CBX5_102K",
        "CBX5_32K"
    ],
    "CBX8": [
        "CBX8_77K",
        "CBX8_82K"
    ],
    "CCDC124": [
        "CCDC124_11K",
        "CCDC124_94K"
    ],
    "CCDC59": [
        "CCDC59_62K"
    ],
    "CCDC6": [
        "CCDC6_119K"
    ],
    "CCDC86": [
        "CCDC86_237K",
        "CCDC86_226K"
    ],
    "CCNA2": [
        "CCNA2_54K"
    ],
    "CCND3": [
        "CCND3_268K"
    ],
    "CCNT1": [
        "CCNT1_395K",
        "CCNT1_590K"
    ],
    "CCS": [
        "CCS_265K"
    ],
    "CCT2": [
        "CCT2_203K",
        "CCT2_250K",
        "CCT2_272K",
        "CCT2_522K",
        "CCT2_263K"
    ],
    "CCT3": [
        "CCT3_381K",
        "CCT3_527K"
    ],
    "CCT4": [
        "CCT4_21K",
        "CCT4_395K",
        "CCT4_292K"
    ],
    "CCT5": [
        "CCT5_514K"
    ],
    "CCT6A": [
        "CCT6A_5K",
        "CCT6A_10K",
        "CCT6A_199K",
        "CCT6A_127K"
    ],
    "CCT7": [
        "CCT7_55K",
        "CCT7_135K"
    ],
    "CCT8": [
        "CCT8_7K",
        "CCT8_16K",
        "CCT8_235K",
        "CCT8_225K",
        "CCT8_326K"
    ],
    "CD2BP2": [
        "CD2BP2_188K",
        "CD2BP2_26K"
    ],
    "CDC37": [
        "CDC37_126K",
        "CDC37_110K"
    ],
    "CDC42": [
        "CDC42_163K"
    ],
    "CDC73": [
        "CDC73_331K",
        "CDC73_354K"
    ],
    "CDCA8": [
        "CDCA8_198K"
    ],
    "CDK13": [
        "CDK13_1045K"
    ],
    "CDK2": [
        "CDK2_9K"
    ],
    "CDK7": [
        "CDK7_328K"
    ],
    "CDV3": [
        "CDV3_232K",
        "CDV3_15K"
    ],
    "CDYL": [
        "CDYL_157K",
        "CDYL_162K",
        "CDYL_172K",
        "CDYL_200K",
        "CDYL_191K",
        "CDYL_175K",
        "CDYL_195K",
        "CDYL_118K",
        "CDYL_147K"
    ],
    "CDYL2": [
        "CDYL2_133K"
    ],
    "CENPE": [
        "CENPE_986K"
    ],
    "CETN1": [
        "CETN1_124K"
    ],
    "CFAP20": [
        "CFAP20_190K"
    ],
    "CFDP1": [
        "CFDP1_268K",
        "CFDP1_167K",
        "CFDP1_150K",
        "CFDP1_243K",
        "CFDP1_237K",
        "CFDP1_194K",
        "CFDP1_230K"
    ],
    "CFL1": [
        "CFL1_44K",
        "CFL1_45K",
        "CFL1_144K",
        "CFL1_22K",
        "CFL1_132K",
        "CFL1_121K",
        "CFL1_114K",
        "CFL1_19K",
        "CFL1_92K"
    ],
    "CGGBP1": [
        "CGGBP1_16K"
    ],
    "CGN": [
        "CGN_374K"
    ],
    "CHAMP1": [
        "CHAMP1_556K",
        "CHAMP1_617K"
    ],
    "CHD1L": [
        "CHD1L_879K"
    ],
    "CHD2": [
        "CHD2_1769K"
    ],
    "CHD3": [
        "CHD3_295K",
        "CHD3_1216K"
    ],
    "CHD4": [
        "CHD4_297K",
        "CHD4_304K",
        "CHD4_696K",
        "CHD4_1341K",
        "CHD4_1396K",
        "CHD4_1206K",
        "CHD4_114K"
    ],
    "CHD8": [
        "CHD8_542K",
        "CHD8_532K"
    ],
    "CHERP": [
        "CHERP_879K",
        "CHERP_872K",
        "CHERP_901K"
    ],
    "CHMP1A": [
        "CHMP1A_40K",
        "CHMP1A_83K"
    ],
    "CHMP1B": [
        "CHMP1B_90K"
    ],
    "CHMP2A": [
        "CHMP2A_94K"
    ],
    "CHMP2B": [
        "CHMP2B_81K"
    ],
    "CHMP3": [
        "CHMP3_6K"
    ],
    "CHMP4A": [
        "CHMP4A_15K"
    ],
    "CHMP4B": [
        "CHMP4B_17K",
        "CHMP4B_14K",
        "CHMP4B_114K",
        "CHMP4B_6K"
    ],
    "CHMP5": [
        "CHMP5_9K",
        "CHMP5_11K"
    ],
    "CHRAC1": [
        "CHRAC1_102K"
    ],
    "CHTF8": [
        "CHTF8_119K"
    ],
    "CHTOP": [
        "CHTOP_8K"
    ],
    "CIAPIN1": [
        "CIAPIN1_181K",
        "CIAPIN1_175K"
    ],
    "CIC": [
        "CIC_1340K",
        "CIC_493K",
        "CIC_1332K"
    ],
    "CKAP4": [
        "CKAP4_272K"
    ],
    "CLASRP": [
        "CLASRP_553K"
    ],
    "CLINT1": [
        "CLINT1_158K",
        "CLINT1_218K"
    ],
    "CLIP1": [
        "CLIP1_14K",
        "CLIP1_857K"
    ],
    "CLTA": [
        "CLTA_223K"
    ],
    "CLTB": [
        "CLTB_204K"
    ],
    "CMTR1": [
        "CMTR1_123K",
        "CMTR1_108K",
        "CMTR1_725K",
        "CMTR1_97K",
        "CMTR1_14K"
    ],
    "CNBP": [
        "CNBP_8K"
    ],
    "CNN2": [
        "CNN2_19K",
        "CNN2_234K",
        "CNN2_25K"
    ],
    "CNN3": [
        "CNN3_6K",
        "CNN3_256K"
    ],
    "CNOT1": [
        "CNOT1_808K"
    ],
    "CNOT3": [
        "CNOT3_105K",
        "CNOT3_72K"
    ],
    "CNOT6L": [
        "CNOT6L_270K"
    ],
    "COIL": [
        "COIL_405K",
        "COIL_209K"
    ],
    "COPS7B": [
        "COPS7B_257K"
    ],
    "CORO1C": [
        "CORO1C_419K",
        "CORO1C_407K"
    ],
    "COX4I1": [
        "COX4I1_60K"
    ],
    "CPNE3": [
        "CPNE3_253K"
    ],
    "CPSF1": [
        "CPSF1_420K",
        "CPSF1_1326K"
    ],
    "CRABP2": [
        "CRABP2_39K",
        "CRABP2_31K",
        "CRABP2_102K",
        "CRABP2_99K",
        "CRABP2_87K"
    ],
    "CREB1": [
        "CREB1_295K",
        "CREB1_122K"
    ],
    "CRIP2": [
        "CRIP2_108K",
        "CRIP2_144K",
        "CRIP2_138K"
    ],
    "CRIPT": [
        "CRIPT_38K"
    ],
    "CRMP1": [
        "CRMP1_7K"
    ],
    "CSDE1": [
        "CSDE1_758K",
        "CSDE1_277K"
    ],
    "CSNK1A1": [
        "CSNK1A1_8K"
    ],
    "CSNK2A2": [
        "CSNK2A2_103K"
    ],
    "CSNK2B": [
        "CSNK2B_212K"
    ],
    "CSRP1": [
        "CSRP1_112K",
        "CSRP1_173K",
        "CSRP1_108K",
        "CSRP1_137K",
        "CSRP1_69K"
    ],
    "CSRP2": [
        "CSRP2_112K"
    ],
    "CTBP2": [
        "CTBP2_6K"
    ],
    "CTCF": [
        "CTCF_202K"
    ],
    "CTDP1": [
        "CTDP1_780K"
    ],
    "CTDSPL2": [
        "CTDSPL2_53K"
    ],
    "CTNNA1": [
        "CTNNA1_842K"
    ],
    "CTSD": [
        "CTSD_348K",
        "CTSD_357K",
        "CTSD_341K"
    ],
    "CTTN": [
        "CTTN_359K",
        "CTTN_87K",
        "CTTN_266K",
        "CTTN_272K",
        "CTTN_193K",
        "CTTN_198K",
        "CTTN_161K",
        "CTTN_79K",
        "CTTN_124K",
        "CTTN_235K",
        "CTTN_309K",
        "CTTN_314K",
        "CTTN_152K",
        "CTTN_226K",
        "CTTN_304K",
        "CTTN_295K",
        "CTTN_263K",
        "CTTN_110K",
        "CTTN_97K",
        "CTTN_107K",
        "CTTN_245K",
        "CTTN_181K",
        "CTTN_144K",
        "CTTN_346K",
        "CTTN_171K",
        "CTTN_208K"
    ],
    "CUL3": [
        "CUL3_6K"
    ],
    "CUL4B": [
        "CUL4B_200K",
        "CUL4B_55K"
    ],
    "CUL5": [
        "CUL5_8K",
        "CUL5_10K"
    ],
    "CWC15": [
        "CWC15_40K",
        "CWC15_91K",
        "CWC15_28K",
        "CWC15_18K"
    ],
    "CWC22": [
        "CWC22_118K"
    ],
    "CWC27": [
        "CWC27_331K",
        "CWC27_230K"
    ],
    "CWF19L1": [
        "CWF19L1_310K"
    ],
    "CYB5R3": [
        "CYB5R3_164K"
    ],
    "CYFIP1": [
        "CYFIP1_540K"
    ],
    "CYRIB": [
        "CYRIB_317K"
    ],
    "CZIB": [
        "CZIB_55K"
    ],
    "DAB2IP": [
        "DAB2IP_84K"
    ],
    "DAP": [
        "DAP_20K",
        "DAP_12K"
    ],
    "DBI": [
        "DBI_77K",
        "DBI_72K"
    ],
    "DBN1": [
        "DBN1_238K"
    ],
    "DBNL": [
        "DBNL_280K",
        "DBNL_144K"
    ],
    "DCAF1": [
        "DCAF1_701K",
        "DCAF1_284K"
    ],
    "DCPS": [
        "DCPS_10K"
    ],
    "DCTN2": [
        "DCTN2_65K"
    ],
    "DCTN6": [
        "DCTN6_182K"
    ],
    "DCUN1D5": [
        "DCUN1D5_8K",
        "DCUN1D5_23K"
    ],
    "DDB1": [
        "DDB1_864K"
    ],
    "DDB2": [
        "DDB2_40K"
    ],
    "DDT": [
        "DDT_33K"
    ],
    "DDX1": [
        "DDX1_82K"
    ],
    "DDX17": [
        "DDX17_109K",
        "DDX17_121K"
    ],
    "DDX18": [
        "DDX18_645K",
        "DDX18_656K"
    ],
    "DDX21": [
        "DDX21_61K"
    ],
    "DDX23": [
        "DDX23_196K"
    ],
    "DDX24": [
        "DDX24_835K"
    ],
    "DDX39B": [
        "DDX39B_334K"
    ],
    "DDX3X": [
        "DDX3X_66K",
        "DDX3X_55K",
        "DDX3X_81K"
    ],
    "DDX42": [
        "DDX42_650K",
        "DDX42_61K",
        "DDX42_930K"
    ],
    "DDX46": [
        "DDX46_272K",
        "DDX46_1025K",
        "DDX46_263K",
        "DDX46_271K",
        "DDX46_776K"
    ],
    "DDX5": [
        "DDX5_33K",
        "DDX5_40K",
        "DDX5_45K",
        "DDX5_197K"
    ],
    "DDX52": [
        "DDX52_131K"
    ],
    "DDX54": [
        "DDX54_838K"
    ],
    "DEK": [
        "DEK_57K",
        "DEK_278K",
        "DEK_221K"
    ],
    "DFFA": [
        "DFFA_313K"
    ],
    "DHCR7": [
        "DHCR7_13K"
    ],
    "DHX15": [
        "DHX15_786K",
        "DHX15_17K",
        "DHX15_515K"
    ],
    "DHX16": [
        "DHX16_1027K",
        "DHX16_340K",
        "DHX16_213K"
    ],
    "DHX38": [
        "DHX38_512K",
        "DHX38_504K"
    ],
    "DHX9": [
        "DHX9_193K",
        "DHX9_146K",
        "DHX9_16K",
        "DHX9_1163K"
    ],
    "DIAPH1": [
        "DIAPH1_35K"
    ],
    "DIDO1": [
        "DIDO1_182K",
        "DIDO1_596K",
        "DIDO1_481K",
        "DIDO1_627K",
        "DIDO1_570K",
        "DIDO1_626K",
        "DIDO1_529K"
    ],
    "DKC1": [
        "DKC1_11K",
        "DKC1_443K"
    ],
    "DNAH10": [
        "DNAH10_67K"
    ],
    "DNAJA2": [
        "DNAJA2_39K"
    ],
    "DNAJB1": [
        "DNAJB1_159K",
        "DNAJB1_195K"
    ],
    "DNAJC17": [
        "DNAJC17_264K",
        "DNAJC17_97K"
    ],
    "DNAJC8": [
        "DNAJC8_231K",
        "DNAJC8_246K"
    ],
    "DNMT1": [
        "DNMT1_341K",
        "DNMT1_173K"
    ],
    "DNMT3A": [
        "DNMT3A_56K"
    ],
    "DNTTIP1": [
        "DNTTIP1_221K",
        "DNTTIP1_190K"
    ],
    "DOCK7": [
        "DOCK7_10K"
    ],
    "DPF2": [
        "DPF2_196K"
    ],
    "DPYSL2": [
        "DPYSL2_525K",
        "DPYSL2_520K"
    ],
    "DPYSL3": [
        "DPYSL3_487K"
    ],
    "DR1": [
        "DR1_95K"
    ],
    "DRG2": [
        "DRG2_46K",
        "DRG2_51K"
    ],
    "DSP": [
        "DSP_2026K"
    ],
    "DSTN": [
        "DSTN_45K",
        "DSTN_22K"
    ],
    "DTWD1": [
        "DTWD1_177K"
    ],
    "DUS1L": [
        "DUS1L_370K",
        "DUS1L_391K"
    ],
    "DUS2": [
        "DUS2_450K"
    ],
    "EAF1": [
        "EAF1_118K"
    ],
    "ECHDC1": [
        "ECHDC1_13K"
    ],
    "ECPAS": [
        "ECPAS_315K"
    ],
    "EDF1": [
        "EDF1_143K",
        "EDF1_135K",
        "EDF1_60K",
        "EDF1_25K",
        "EDF1_50K"
    ],
    "EEA1": [
        "EEA1_1396K"
    ],
    "EEF1A1P5": [
        "EEF1A1P5_453K",
        "EEF1A1P5_44K",
        "EEF1A1P5_386K",
        "EEF1A1P5_392K",
        "EEF1A1P5_165K",
        "EEF1A1P5_439K"
    ],
    "EEF1A2": [
        "EEF1A2_392K",
        "EEF1A2_439K",
        "EEF1A2_453K"
    ],
    "EEF1B2": [
        "EEF1B2_129K"
    ],
    "EEF1D": [
        "EEF1D_242K",
        "EEF1D_17K",
        "EEF1D_117K"
    ],
    "EEF1G": [
        "EEF1G_434K",
        "EEF1G_277K",
        "EEF1G_220K",
        "EEF1G_401K",
        "EEF1G_212K",
        "EEF1G_132K"
    ],
    "EEF2": [
        "EEF2_571K",
        "EEF2_572K",
        "EEF2_445K",
        "EEF2_594K",
        "EEF2_239K",
        "EEF2_275K",
        "EEF2_152K",
        "EEF2_438K",
        "EEF2_439K",
        "EEF2_314K",
        "EEF2_318K",
        "EEF2_322K",
        "EEF2_407K",
        "EEF2_512K",
        "EEF2_426K"
    ],
    "EEFSEC": [
        "EEFSEC_549K"
    ],
    "EFHD1": [
        "EFHD1_189K"
    ],
    "EHMT1": [
        "EHMT1_239K",
        "EHMT1_432K",
        "EHMT1_439K",
        "EHMT1_327K",
        "EHMT1_219K"
    ],
    "EHMT2": [
        "EHMT2_348K",
        "EHMT2_229K",
        "EHMT2_226K"
    ],
    "EIF1AX": [
        "EIF1AX_104K"
    ],
    "EIF2S1": [
        "EIF2S1_61K"
    ],
    "EIF2S2": [
        "EIF2S2_87K",
        "EIF2S2_324K"
    ],
    "EIF3A": [
        "EIF3A_632K"
    ],
    "EIF3B": [
        "EIF3B_257K",
        "EIF3B_729K"
    ],
    "EIF3C": [
        "EIF3C_894K"
    ],
    "EIF3D": [
        "EIF3D_142K",
        "EIF3D_41K",
        "EIF3D_53K",
        "EIF3D_90K"
    ],
    "EIF3E": [
        "EIF3E_409K"
    ],
    "EIF3G": [
        "EIF3G_153K",
        "EIF3G_212K"
    ],
    "EIF3J": [
        "EIF3J_224K",
        "EIF3J_122K"
    ],
    "EIF4A1": [
        "EIF4A1_284K",
        "EIF4A1_238K",
        "EIF4A1_174K"
    ],
    "EIF4A3": [
        "EIF4A3_152K"
    ],
    "EIF4B": [
        "EIF4B_365K",
        "EIF4B_333K",
        "EIF4B_586K"
    ],
    "EIF4E": [
        "EIF4E_206K"
    ],
    "EIF4EBP1": [
        "EIF4EBP1_69K"
    ],
    "EIF4G1": [
        "EIF4G1_950K",
        "EIF4G1_1206K",
        "EIF4G1_1095K",
        "EIF4G1_1071K",
        "EIF4G1_1188K",
        "EIF4G1_1026K"
    ],
    "EIF4G2": [
        "EIF4G2_31K",
        "EIF4G2_484K",
        "EIF4G2_49K"
    ],
    "EIF4H": [
        "EIF4H_80K",
        "EIF4H_123K"
    ],
    "EIF5A": [
        "EIF5A_39K",
        "EIF5A_121K"
    ],
    "EIF5B": [
        "EIF5B_410K"
    ],
    "ELL": [
        "ELL_164K",
        "ELL_190K"
    ],
    "ELOA": [
        "ELOA_719K",
        "ELOA_161K",
        "ELOA_479K"
    ],
    "ELOB": [
        "ELOB_11K"
    ],
    "EMD": [
        "EMD_79K"
    ],
    "EMSY": [
        "EMSY_655K"
    ],
    "ENO1": [
        "ENO1_126K",
        "ENO1_71K",
        "ENO1_80K",
        "ENO1_335K",
        "ENO1_64K",
        "ENO1_420K",
        "ENO1_193K",
        "ENO1_81K",
        "ENO1_89K",
        "ENO1_406K",
        "ENO1_256K",
        "ENO1_5K",
        "ENO1_233K"
    ],
    "ENO3": [
        "ENO3_81K"
    ],
    "ENSA": [
        "ENSA_40K",
        "ENSA_107K",
        "ENSA_114K",
        "ENSA_80K",
        "ENSA_56K",
        "ENSA_74K"
    ],
    "EP400": [
        "EP400_2811K",
        "EP400_1553K"
    ],
    "EPB41L3": [
        "EPB41L3_1027K"
    ],
    "EPPK1": [
        "EPPK1_2525K",
        "EPPK1_2753K"
    ],
    "EPS15L1": [
        "EPS15L1_546K"
    ],
    "EPS8": [
        "EPS8_309K",
        "EPS8_42K"
    ],
    "ERCC3": [
        "ERCC3_222K"
    ],
    "ERF": [
        "ERF_71K",
        "ERF_378K"
    ],
    "ESF1": [
        "ESF1_48K",
        "ESF1_55K",
        "ESF1_736K",
        "ESF1_800K"
    ],
    "ETFA": [
        "ETFA_226K"
    ],
    "ETV3": [
        "ETV3_224K"
    ],
    "EXOC2": [
        "EXOC2_197K"
    ],
    "EXOC8": [
        "EXOC8_702K"
    ],
    "EXOSC10": [
        "EXOSC10_835K"
    ],
    "EYA3": [
        "EYA3_291K"
    ],
    "EZR": [
        "EZR_344K",
        "EZR_72K"
    ],
    "FAM50A": [
        "FAM50A_76K",
        "FAM50A_5K",
        "FAM50A_100K",
        "FAM50A_95K"
    ],
    "FAM53C": [
        "FAM53C_373K"
    ],
    "FANCD2": [
        "FANCD2_322K",
        "FANCD2_9K",
        "FANCD2_22K"
    ],
    "FARSB": [
        "FARSB_47K"
    ],
    "FASN": [
        "FASN_2436K",
        "FASN_673K",
        "FASN_2186K",
        "FASN_1871K",
        "FASN_1065K",
        "FASN_528K",
        "FASN_1704K",
        "FASN_1847K"
    ],
    "FAU": [
        "FAU_51K"
    ],
    "FBL": [
        "FBL_102K",
        "FBL_121K"
    ],
    "FBP2": [
        "FBP2_208K"
    ],
    "FDPS": [
        "FDPS_123K",
        "FDPS_112K"
    ],
    "FEN1": [
        "FEN1_252K",
        "FEN1_201K",
        "FEN1_99K",
        "FEN1_354K"
    ],
    "FER": [
        "FER_420K"
    ],
    "FGFRL1": [
        "FGFRL1_85K"
    ],
    "FIP1L1": [
        "FIP1L1_294K",
        "FIP1L1_135K"
    ],
    "FKBP3": [
        "FKBP3_99K",
        "FKBP3_80K",
        "FKBP3_86K",
        "FKBP3_48K",
        "FKBP3_89K"
    ],
    "FKBP4": [
        "FKBP4_390K",
        "FKBP4_409K",
        "FKBP4_274K",
        "FKBP4_287K"
    ],
    "FKBP8": [
        "FKBP8_366K"
    ],
    "FLNA": [
        "FLNA_120K",
        "FLNA_1294K",
        "FLNA_2623K",
        "FLNA_994K",
        "FLNA_2024K",
        "FLNA_2569K",
        "FLNA_700K",
        "FLNA_1007K",
        "FLNA_1071K",
        "FLNA_1547K",
        "FLNA_771K",
        "FLNA_1450K",
        "FLNA_781K",
        "FLNA_508K"
    ],
    "FLNB": [
        "FLNB_1979K"
    ],
    "FLNC": [
        "FLNC_2195K"
    ],
    "FLYWCH2": [
        "FLYWCH2_41K",
        "FLYWCH2_49K"
    ],
    "FNBP4": [
        "FNBP4_792K",
        "FNBP4_949K",
        "FNBP4_290K",
        "FNBP4_942K"
    ],
    "FOSL2": [
        "FOSL2_104K"
    ],
    "FOXA1": [
        "FOXA1_160K"
    ],
    "FOXJ3": [
        "FOXJ3_55K"
    ],
    "FOXK2": [
        "FOXK2_223K",
        "FOXK2_161K"
    ],
    "FOXP1": [
        "FOXP1_548K"
    ],
    "FRG1": [
        "FRG1_220K",
        "FRG1_212K"
    ],
    "FSCN1": [
        "FSCN1_399K",
        "FSCN1_241K"
    ],
    "FTSJ3": [
        "FTSJ3_14K",
        "FTSJ3_233K"
    ],
    "FUBP1": [
        "FUBP1_394K"
    ],
    "FUS": [
        "FUS_510K",
        "FUS_316K",
        "FUS_312K"
    ],
    "G6PD": [
        "G6PD_497K",
        "G6PD_82K",
        "G6PD_432K"
    ],
    "GABPA": [
        "GABPA_292K"
    ],
    "GADD45GIP1": [
        "GADD45GIP1_106K"
    ],
    "GANAB": [
        "GANAB_908K"
    ],
    "GAPDH": [
        "GAPDH_117K",
        "GAPDH_215K",
        "GAPDH_263K",
        "GAPDH_254K",
        "GAPDH_194K",
        "GAPDH_334K"
    ],
    "GATAD2A": [
        "GATAD2A_499K",
        "GATAD2A_451K",
        "GATAD2A_584K",
        "GATAD2A_204K",
        "GATAD2A_487K",
        "GATAD2A_349K"
    ],
    "GATAD2B": [
        "GATAD2B_52K",
        "GATAD2B_33K",
        "GATAD2B_462K"
    ],
    "GATD3": [
        "GATD3_233K"
    ],
    "GCLM": [
        "GCLM_34K"
    ],
    "GCN1": [
        "GCN1_821K"
    ],
    "GDAP1": [
        "GDAP1_203K"
    ],
    "GDI2": [
        "GDI2_210K",
        "GDI2_164K",
        "GDI2_269K",
        "GDI2_112K"
    ],
    "GEMIN5": [
        "GEMIN5_725K"
    ],
    "GGCT": [
        "GGCT_118K"
    ],
    "GIGYF2": [
        "GIGYF2_1103K"
    ],
    "GINS3": [
        "GINS3_207K"
    ],
    "GIPC1": [
        "GIPC1_10K"
    ],
    "GLS": [
        "GLS_164K"
    ],
    "GLUD1": [
        "GLUD1_503K"
    ],
    "GMFB": [
        "GMFB_25K"
    ],
    "GMFG": [
        "GMFG_25K"
    ],
    "GMNN": [
        "GMNN_50K"
    ],
    "GMPS": [
        "GMPS_627K"
    ],
    "GNL2": [
        "GNL2_16K"
    ],
    "GOT2": [
        "GOT2_82K",
        "GOT2_90K",
        "GOT2_338K",
        "GOT2_363K"
    ],
    "GPALPP1": [
        "GPALPP1_282K"
    ],
    "GPATCH8": [
        "GPATCH8_1160K",
        "GPATCH8_447K"
    ],
    "GPI": [
        "GPI_454K"
    ],
    "GRHL2": [
        "GRHL2_84K"
    ],
    "GRSF1": [
        "GRSF1_340K"
    ],
    "GSE1": [
        "GSE1_814K",
        "GSE1_1043K",
        "GSE1_441K",
        "GSE1_739K",
        "GSE1_624K",
        "GSE1_973K"
    ],
    "GSPT1": [
        "GSPT1_208K"
    ],
    "GSTM3": [
        "GSTM3_98K",
        "GSTM3_73K"
    ],
    "GSTO1": [
        "GSTO1_160K"
    ],
    "GTF2E1": [
        "GTF2E1_330K"
    ],
    "GTF2E2": [
        "GTF2E2_271K",
        "GTF2E2_252K"
    ],
    "GTF2F1": [
        "GTF2F1_407K",
        "GTF2F1_435K",
        "GTF2F1_421K"
    ],
    "GTF2F2": [
        "GTF2F2_226K"
    ],
    "GTF2H3": [
        "GTF2H3_298K"
    ],
    "GTF2I": [
        "GTF2I_130K",
        "GTF2I_670K",
        "GTF2I_450K",
        "GTF2I_353K",
        "GTF2I_664K",
        "GTF2I_435K",
        "GTF2I_192K",
        "GTF2I_219K",
        "GTF2I_561K"
    ],
    "GTF3C1": [
        "GTF3C1_530K",
        "GTF3C1_321K",
        "GTF3C1_770K",
        "GTF3C1_517K",
        "GTF3C1_529K"
    ],
    "GTF3C4": [
        "GTF3C4_740K",
        "GTF3C4_633K"
    ],
    "GTF3C5": [
        "GTF3C5_339K"
    ],
    "GTPBP4": [
        "GTPBP4_352K",
        "GTPBP4_29K",
        "GTPBP4_619K"
    ],
    "H1-0": [
        "H1-0_149K",
        "H1-0_82K"
    ],
    "H1-10": [
        "H1-10_207K",
        "H1-10_199K",
        "H1-10_23K"
    ],
    "H1-2": [
        "H1-2_75K",
        "H1-2_52K",
        "H1-2_106K",
        "H1-2_97K",
        "H1-2_64K",
        "H1-2_34K",
        "H1-2_63K",
        "H1-2_90K",
        "H1-2_168K",
        "H1-2_201K",
        "H1-2_17K"
    ],
    "H1-3": [
        "H1-3_141K"
    ],
    "H1-4": [
        "H1-4_159K",
        "H1-4_17K"
    ],
    "H1-5": [
        "H1-5_132K",
        "H1-5_78K",
        "H1-5_188K",
        "H1-5_67K",
        "H1-5_37K",
        "H1-5_66K",
        "H1-5_17K"
    ],
    "H2AC14": [
        "H2AC14_37K",
        "H2AC14_96K"
    ],
    "H2AC21": [
        "H2AC21_120K",
        "H2AC21_128K"
    ],
    "H2AC6": [
        "H2AC6_96K"
    ],
    "H2AX": [
        "H2AX_120K",
        "H2AX_128K"
    ],
    "H2AZ2": [
        "H2AZ2_116K"
    ],
    "H2BC13": [
        "H2BC13_6K"
    ],
    "H2BC14": [
        "H2BC14_6K"
    ],
    "H2BC15": [
        "H2BC15_6K"
    ],
    "H2BC17": [
        "H2BC17_35K"
    ],
    "H2BC18": [
        "H2BC18_21K"
    ],
    "H2BC3": [
        "H2BC3_21K"
    ],
    "H2BC4": [
        "H2BC4_6K"
    ],
    "H2BC5": [
        "H2BC5_6K"
    ],
    "H2BC9": [
        "H2BC9_21K",
        "H2BC9_121K",
        "H2BC9_117K",
        "H2BC9_86K",
        "H2BC9_109K",
        "H2BC9_6K",
        "H2BC9_47K",
        "H2BC9_35K"
    ],
    "H2BS1": [
        "H2BS1_86K"
    ],
    "H2BU1": [
        "H2BU1_6K"
    ],
    "H3-3A": [
        "H3-3A_28K"
    ],
    "H3C15": [
        "H3C15_80K",
        "H3C15_24K",
        "H3C15_28K",
        "H3C15_15K",
        "H3C15_123K",
        "H3C15_57K"
    ],
    "H4C1": [
        "H4C1_78K",
        "H4C1_32K",
        "H4C1_80K"
    ],
    "HABP4": [
        "HABP4_321K"
    ],
    "HACD3": [
        "HACD3_85K"
    ],
    "HADHA": [
        "HADHA_415K"
    ],
    "HCFC1": [
        "HCFC1_836K",
        "HCFC1_820K",
        "HCFC1_345K",
        "HCFC1_2024K",
        "HCFC1_813K"
    ],
    "HCK": [
        "HCK_248K"
    ],
    "HDAC1": [
        "HDAC1_412K",
        "HDAC1_473K",
        "HDAC1_444K"
    ],
    "HDAC2": [
        "HDAC2_481K",
        "HDAC2_452K"
    ],
    "HDAC7": [
        "HDAC7_88K",
        "HDAC7_389K"
    ],
    "HDGF": [
        "HDGF_11K",
        "HDGF_39K",
        "HDGF_106K",
        "HDGF_151K"
    ],
    "HDGFL2": [
        "HDGFL2_466K",
        "HDGFL2_286K",
        "HDGFL2_163K",
        "HDGFL2_554K"
    ],
    "HDLBP": [
        "HDLBP_1071K"
    ],
    "HEATR1": [
        "HEATR1_1180K"
    ],
    "HELLS": [
        "HELLS_514K"
    ],
    "HINT1": [
        "HINT1_7K"
    ],
    "HIRIP3": [
        "HIRIP3_77K"
    ],
    "HK1": [
        "HK1_777K"
    ],
    "HLTF": [
        "HLTF_417K"
    ],
    "HMBS": [
        "HMBS_70K"
    ],
    "HMG20B": [
        "HMG20B_149K",
        "HMG20B_6K"
    ],
    "HMGA1": [
        "HMGA1_55K",
        "HMGA1_89K",
        "HMGA1_31K",
        "HMGA1_7K",
        "HMGA1_15K"
    ],
    "HMGA2": [
        "HMGA2_82K",
        "HMGA2_90K"
    ],
    "HMGB1": [
        "HMGB1_76K",
        "HMGB1_82K",
        "HMGB1_65K",
        "HMGB1_90K",
        "HMGB1_127K",
        "HMGB1_128K",
        "HMGB1_7K",
        "HMGB1_43K",
        "HMGB1_114K",
        "HMGB1_88K",
        "HMGB1_177K",
        "HMGB1_30K",
        "HMGB1_55K",
        "HMGB1_157K"
    ],
    "HMGB2": [
        "HMGB2_89K",
        "HMGB2_141K",
        "HMGB2_147K",
        "HMGB2_76K",
        "HMGB2_3K",
        "HMGB2_30K",
        "HMGB2_127K"
    ],
    "HMGB3": [
        "HMGB3_161K",
        "HMGB3_76K",
        "HMGB3_170K",
        "HMGB3_112K",
        "HMGB3_155K"
    ],
    "HMGN1": [
        "HMGN1_61K",
        "HMGN1_31K",
        "HMGN1_14K"
    ],
    "HMGN2": [
        "HMGN2_31K",
        "HMGN2_40K",
        "HMGN2_82K"
    ],
    "HMGN3": [
        "HMGN3_55K",
        "HMGN3_20K"
    ],
    "HNRNPA0": [
        "HNRNPA0_159K",
        "HNRNPA0_133K",
        "HNRNPA0_176K"
    ],
    "HNRNPA1": [
        "HNRNPA1_105K",
        "HNRNPA1_8K",
        "HNRNPA1_3K",
        "HNRNPA1_350K"
    ],
    "HNRNPA2B1": [
        "HNRNPA2B1_104K",
        "HNRNPA2B1_112K"
    ],
    "HNRNPA3": [
        "HNRNPA3_118K",
        "HNRNPA3_126K"
    ],
    "HNRNPAB": [
        "HNRNPAB_223K",
        "HNRNPAB_215K",
        "HNRNPAB_232K",
        "HNRNPAB_130K"
    ],
    "HNRNPC": [
        "HNRNPC_8K",
        "HNRNPC_157K",
        "HNRNPC_223K",
        "HNRNPC_198K",
        "HNRNPC_30K",
        "HNRNPC_189K",
        "HNRNPC_197K",
        "HNRNPC_176K",
        "HNRNPC_42K"
    ],
    "HNRNPD": [
        "HNRNPD_243K"
    ],
    "HNRNPF": [
        "HNRNPF_200K",
        "HNRNPF_224K"
    ],
    "HNRNPH1": [
        "HNRNPH1_200K"
    ],
    "HNRNPK": [
        "HNRNPK_405K",
        "HNRNPK_52K",
        "HNRNPK_60K"
    ],
    "HNRNPL": [
        "HNRNPL_62K",
        "HNRNPL_538K"
    ],
    "HNRNPM": [
        "HNRNPM_134K",
        "HNRNPM_388K",
        "HNRNPM_381K",
        "HNRNPM_651K"
    ],
    "HNRNPU": [
        "HNRNPU_609K",
        "HNRNPU_635K",
        "HNRNPU_186K",
        "HNRNPU_436K",
        "HNRNPU_12K",
        "HNRNPU_17K",
        "HNRNPU_21K",
        "HNRNPU_9K"
    ],
    "HNRNPUL2": [
        "HNRNPUL2_7K"
    ],
    "HP1BP3": [
        "HP1BP3_482K",
        "HP1BP3_517K"
    ],
    "HSD17B4": [
        "HSD17B4_424K"
    ],
    "HSP90AA1": [
        "HSP90AA1_631K",
        "HSP90AA1_539K",
        "HSP90AA1_489K",
        "HSP90AA1_576K",
        "HSP90AA1_458K",
        "HSP90AA1_585K",
        "HSP90AA1_446K"
    ],
    "HSP90AB1": [
        "HSP90AB1_107K",
        "HSP90AB1_275K",
        "HSP90AB1_284K",
        "HSP90AB1_399K",
        "HSP90AB1_607K",
        "HSP90AB1_354K",
        "HSP90AB1_286K",
        "HSP90AB1_64K",
        "HSP90AB1_559K",
        "HSP90AB1_347K",
        "HSP90AB1_531K",
        "HSP90AB1_481K",
        "HSP90AB1_263K",
        "HSP90AB1_624K",
        "HSP90AB1_69K",
        "HSP90AB1_568K",
        "HSP90AB1_438K"
    ],
    "HSP90B1": [
        "HSP90B1_682K",
        "HSP90B1_161K",
        "HSP90B1_168K",
        "HSP90B1_455K",
        "HSP90B1_593K",
        "HSP90B1_404K",
        "HSP90B1_633K",
        "HSP90B1_663K",
        "HSP90B1_95K",
        "HSP90B1_97K"
    ],
    "HSPA1B": [
        "HSPA1B_507K",
        "HSPA1B_77K",
        "HSPA1B_526K",
        "HSPA1B_71K",
        "HSPA1B_108K"
    ],
    "HSPA4": [
        "HSPA4_557K",
        "HSPA4_560K",
        "HSPA4_53K",
        "HSPA4_477K"
    ],
    "HSPA4L": [
        "HSPA4L_573K"
    ],
    "HSPA5": [
        "HSPA5_163K",
        "HSPA5_370K",
        "HSPA5_154K",
        "HSPA5_523K",
        "HSPA5_96K"
    ],
    "HSPA8": [
        "HSPA8_524K",
        "HSPA8_451K",
        "HSPA8_597K",
        "HSPA8_601K",
        "HSPA8_500K",
        "HSPA8_507K",
        "HSPA8_319K",
        "HSPA8_187K",
        "HSPA8_512K",
        "HSPA8_128K",
        "HSPA8_526K",
        "HSPA8_589K",
        "HSPA8_71K",
        "HSPA8_102K",
        "HSPA8_108K",
        "HSPA8_159K"
    ],
    "HSPA9": [
        "HSPA9_300K",
        "HSPA9_288K",
        "HSPA9_625K",
        "HSPA9_612K",
        "HSPA9_567K",
        "HSPA9_206K",
        "HSPA9_368K"
    ],
    "HSPB1": [
        "HSPB1_198K",
        "HSPB1_123K",
        "HSPB1_114K"
    ],
    "HSPD1": [
        "HSPD1_82K",
        "HSPD1_191K",
        "HSPD1_364K",
        "HSPD1_523K",
        "HSPD1_202K",
        "HSPD1_133K",
        "HSPD1_396K",
        "HSPD1_417K",
        "HSPD1_91K"
    ],
    "HSPE1": [
        "HSPE1_66K",
        "HSPE1_70K",
        "HSPE1_36K",
        "HSPE1_56K",
        "HSPE1_8K",
        "HSPE1_28K"
    ],
    "HTATSF1": [
        "HTATSF1_221K",
        "HTATSF1_239K"
    ],
    "HYOU1": [
        "HYOU1_75K"
    ],
    "HYPK": [
        "HYPK_35K"
    ],
    "ICE2": [
        "ICE2_641K"
    ],
    "IDH2": [
        "IDH2_384K"
    ],
    "IK": [
        "IK_54K",
        "IK_541K",
        "IK_534K"
    ],
    "IL27": [
        "IL27_56K"
    ],
    "ILF3": [
        "ILF3_600K",
        "ILF3_454K"
    ],
    "ILKAP": [
        "ILKAP_273K"
    ],
    "IMPACT": [
        "IMPACT_303K"
    ],
    "IMPDH2": [
        "IMPDH2_511K"
    ],
    "INIP": [
        "INIP_53K"
    ],
    "INO80B": [
        "INO80B_74K"
    ],
    "INO80D": [
        "INO80D_173K"
    ],
    "INTS1": [
        "INTS1_100K"
    ],
    "INTS12": [
        "INTS12_247K",
        "INTS12_222K"
    ],
    "INTS3": [
        "INTS3_7K",
        "INTS3_990K"
    ],
    "INTS4": [
        "INTS4_35K",
        "INTS4_26K"
    ],
    "IPO11": [
        "IPO11_337K"
    ],
    "IPO5": [
        "IPO5_800K"
    ],
    "IQGAP1": [
        "IQGAP1_1475K",
        "IQGAP1_1541K"
    ],
    "IRF2BP1": [
        "IRF2BP1_306K",
        "IRF2BP1_382K",
        "IRF2BP1_73K"
    ],
    "ISOC1": [
        "ISOC1_279K"
    ],
    "ITPK1": [
        "ITPK1_340K"
    ],
    "JMJD1C": [
        "JMJD1C_2076K",
        "JMJD1C_1486K",
        "JMJD1C_676K",
        "JMJD1C_626K",
        "JMJD1C_2128K"
    ],
    "JPT1": [
        "JPT1_148K"
    ],
    "JPT2": [
        "JPT2_176K",
        "JPT2_67K"
    ],
    "JUNB": [
        "JUNB_284K"
    ],
    "KARS1": [
        "KARS1_20K"
    ],
    "KAT7": [
        "KAT7_263K",
        "KAT7_90K"
    ],
    "KBTBD2": [
        "KBTBD2_339K"
    ],
    "KCNJ3": [
        "KCNJ3_402K"
    ],
    "KDM1B": [
        "KDM1B_11K"
    ],
    "KDM2B": [
        "KDM2B_794K"
    ],
    "KDM3B": [
        "KDM3B_449K",
        "KDM3B_876K",
        "KDM3B_883K"
    ],
    "KDM5C": [
        "KDM5C_235K"
    ],
    "KHDRBS1": [
        "KHDRBS1_432K",
        "KHDRBS1_424K"
    ],
    "KHSRP": [
        "KHSRP_71K",
        "KHSRP_347K"
    ],
    "KIAA1143": [
        "KIAA1143_108K",
        "KIAA1143_117K",
        "KIAA1143_102K"
    ],
    "KIF23": [
        "KIF23_956K"
    ],
    "KIF2A": [
        "KIF2A_165K",
        "KIF2A_102K"
    ],
    "KIFC1": [
        "KIFC1_61K",
        "KIFC1_479K"
    ],
    "KMT2A": [
        "KMT2A_3219K"
    ],
    "KPNA1": [
        "KPNA1_17K",
        "KPNA1_6K"
    ],
    "KPNA2": [
        "KPNA2_108K"
    ],
    "KPNA6": [
        "KPNA6_18K"
    ],
    "KRT18": [
        "KRT18_417K",
        "KRT18_426K",
        "KRT18_187K",
        "KRT18_317K",
        "KRT18_247K"
    ],
    "LAD1": [
        "LAD1_6K"
    ],
    "LANCL1": [
        "LANCL1_128K"
    ],
    "LARP1": [
        "LARP1_367K"
    ],
    "LARP7": [
        "LARP7_250K",
        "LARP7_318K",
        "LARP7_560K"
    ],
    "LASP1": [
        "LASP1_96K",
        "LASP1_112K",
        "LASP1_75K",
        "LASP1_87K"
    ],
    "LDHA": [
        "LDHA_81K",
        "LDHA_318K"
    ],
    "LDHB": [
        "LDHB_308K",
        "LDHB_156K"
    ],
    "LENG8": [
        "LENG8_494K"
    ],
    "LEO1": [
        "LEO1_627K",
        "LEO1_503K"
    ],
    "LIG1": [
        "LIG1_226K"
    ],
    "LIG3": [
        "LIG3_581K"
    ],
    "LIMA1": [
        "LIMA1_189K"
    ],
    "LIMD2": [
        "LIMD2_99K",
        "LIMD2_28K"
    ],
    "LMNA": [
        "LMNA_260K",
        "LMNA_155K",
        "LMNA_123K",
        "LMNA_420K",
        "LMNA_378K",
        "LMNA_90K",
        "LMNA_97K",
        "LMNA_180K",
        "LMNA_135K",
        "LMNA_108K",
        "LMNA_233K",
        "LMNA_270K"
    ],
    "LMNB1": [
        "LMNB1_156K"
    ],
    "LMNB2": [
        "LMNB2_81K"
    ],
    "LPP": [
        "LPP_44K"
    ],
    "LRPPRC": [
        "LRPPRC_1347K"
    ],
    "LRRC41": [
        "LRRC41_375K"
    ],
    "LRRC59": [
        "LRRC59_73K",
        "LRRC59_135K"
    ],
    "LSM7": [
        "LSM7_26K"
    ],
    "LXN": [
        "LXN_167K",
        "LXN_36K",
        "LXN_38K"
    ],
    "MACF1": [
        "MACF1_6588K",
        "MACF1_5398K",
        "MACF1_859K"
    ],
    "MACROH2A1": [
        "MACROH2A1_123K",
        "MACROH2A1_134K"
    ],
    "MAD1L1": [
        "MAD1L1_61K"
    ],
    "MAGOH": [
        "MAGOH_41K"
    ],
    "MAP2K4": [
        "MAP2K4_45K",
        "MAP2K4_86K"
    ],
    "MAP4": [
        "MAP4_718K",
        "MAP4_318K",
        "MAP4_1034K",
        "MAP4_998K",
        "MAP4_852K",
        "MAP4_938K",
        "MAP4_997K"
    ],
    "MAP6": [
        "MAP6_318K"
    ],
    "MAPRE1": [
        "MAPRE1_151K",
        "MAPRE1_174K"
    ],
    "MAPRE3": [
        "MAPRE3_151K"
    ],
    "MARF1": [
        "MARF1_1188K"
    ],
    "MATR3": [
        "MATR3_3K"
    ],
    "MBD2": [
        "MBD2_253K",
        "MBD2_185K",
        "MBD2_212K"
    ],
    "MBD3": [
        "MBD3_41K"
    ],
    "MBD4": [
        "MBD4_239K"
    ],
    "MCM3": [
        "MCM3_556K",
        "MCM3_152K"
    ],
    "MCRIP2": [
        "MCRIP2_10K"
    ],
    "MDC1": [
        "MDC1_472K",
        "MDC1_1806K",
        "MDC1_540K",
        "MDC1_351K",
        "MDC1_1885K"
    ],
    "MDH1": [
        "MDH1_205K",
        "MDH1_118K"
    ],
    "MDH2": [
        "MDH2_301K",
        "MDH2_307K",
        "MDH2_239K"
    ],
    "MECP2": [
        "MECP2_210K",
        "MECP2_249K",
        "MECP2_435K",
        "MECP2_449K",
        "MECP2_331K",
        "MECP2_256K",
        "MECP2_266K",
        "MECP2_284K",
        "MECP2_200K",
        "MECP2_22K",
        "MECP2_219K",
        "MECP2_304K"
    ],
    "MED1": [
        "MED1_1396K",
        "MED1_686K",
        "MED1_1382K"
    ],
    "MED27": [
        "MED27_145K"
    ],
    "MEF2D": [
        "MEF2D_511K"
    ],
    "METTL1": [
        "METTL1_18K"
    ],
    "METTL3": [
        "METTL3_27K"
    ],
    "METTL5": [
        "METTL5_191K"
    ],
    "MFAP1": [
        "MFAP1_329K",
        "MFAP1_381K"
    ],
    "MGA": [
        "MGA_2988K"
    ],
    "MIDEAS": [
        "MIDEAS_169K",
        "MIDEAS_940K",
        "MIDEAS_493K"
    ],
    "MIP": [
        "MIP_238K"
    ],
    "MKI67": [
        "MKI67_2500K",
        "MKI67_2017K",
        "MKI67_379K",
        "MKI67_910K",
        "MKI67_458K",
        "MKI67_2245K",
        "MKI67_2892K",
        "MKI67_263K",
        "MKI67_537K",
        "MKI67_548K",
        "MKI67_1452K",
        "MKI67_886K",
        "MKI67_2473K",
        "MKI67_3049K",
        "MKI67_3206K"
    ],
    "MLH1": [
        "MLH1_123K"
    ],
    "MLLT1": [
        "MLLT1_327K"
    ],
    "MNAT1": [
        "MNAT1_176K"
    ],
    "MOB1A": [
        "MOB1A_17K",
        "MOB1A_11K"
    ],
    "MORC2": [
        "MORC2_643K",
        "MORC2_580K",
        "MORC2_819K"
    ],
    "MORC3": [
        "MORC3_555K"
    ],
    "MORF4L1": [
        "MORF4L1_127K",
        "MORF4L1_143K"
    ],
    "MPHOSPH10": [
        "MPHOSPH10_612K"
    ],
    "MPHOSPH6": [
        "MPHOSPH6_11K",
        "MPHOSPH6_127K"
    ],
    "MPHOSPH8": [
        "MPHOSPH8_350K"
    ],
    "MRGBP": [
        "MRGBP_200K",
        "MRGBP_185K"
    ],
    "MRPL12": [
        "MRPL12_163K"
    ],
    "MRTO4": [
        "MRTO4_14K"
    ],
    "MSH2": [
        "MSH2_537K"
    ],
    "MSH6": [
        "MSH6_324K",
        "MSH6_22K"
    ],
    "MSL1": [
        "MSL1_346K",
        "MSL1_9K"
    ],
    "MSL2": [
        "MSL2_399K"
    ],
    "MSN": [
        "MSN_262K",
        "MSN_254K",
        "MSN_143K",
        "MSN_523K",
        "MSN_72K",
        "MSN_3K",
        "MSN_162K"
    ],
    "MTA1": [
        "MTA1_670K",
        "MTA1_462K",
        "MTA1_631K"
    ],
    "MTA2": [
        "MTA2_504K",
        "MTA2_508K",
        "MTA2_531K",
        "MTA2_533K",
        "MTA2_559K",
        "MTA2_539K",
        "MTA2_618K",
        "MTA2_595K",
        "MTA2_460K"
    ],
    "MTAP": [
        "MTAP_32K"
    ],
    "MTHFD1": [
        "MTHFD1_66K",
        "MTHFD1_543K",
        "MTHFD1_825K"
    ],
    "MTPN": [
        "MTPN_24K"
    ],
    "MTREX": [
        "MTREX_358K",
        "MTREX_369K",
        "MTREX_35K"
    ],
    "MTRR": [
        "MTRR_676K"
    ],
    "MYBBP1A": [
        "MYBBP1A_1172K",
        "MYBBP1A_1317K"
    ],
    "MYEF2": [
        "MYEF2_85K"
    ],
    "MYH10": [
        "MYH10_1219K",
        "MYH10_1649K"
    ],
    "MYH9": [
        "MYH9_1219K",
        "MYH9_1518K",
        "MYH9_1525K",
        "MYH9_1477K",
        "MYH9_1918K",
        "MYH9_560K",
        "MYH9_1404K",
        "MYH9_202K",
        "MYH9_1445K",
        "MYH9_1249K",
        "MYH9_1802K",
        "MYH9_1274K",
        "MYH9_1459K",
        "MYH9_651K",
        "MYH9_1806K"
    ],
    "MYL6": [
        "MYL6_81K",
        "MYL6_56K"
    ],
    "MYO6": [
        "MYO6_403K"
    ],
    "NAA15": [
        "NAA15_605K"
    ],
    "NAB1": [
        "NAB1_129K"
    ],
    "NAB2": [
        "NAB2_361K"
    ],
    "NABP1": [
        "NABP1_37K"
    ],
    "NACC1": [
        "NACC1_183K"
    ],
    "NAMPT": [
        "NAMPT_48K"
    ],
    "NANOGNB": [
        "NANOGNB_92K"
    ],
    "NANS": [
        "NANS_74K"
    ],
    "NAP1L4": [
        "NAP1L4_140K",
        "NAP1L4_146K"
    ],
    "NAT10": [
        "NAT10_989K",
        "NAT10_999K"
    ],
    "NCAPG": [
        "NCAPG_943K"
    ],
    "NCAPH": [
        "NCAPH_488K"
    ],
    "NCBP2": [
        "NCBP2_151K"
    ],
    "NCBP3": [
        "NCBP3_451K",
        "NCBP3_487K"
    ],
    "NCDN": [
        "NCDN_272K"
    ],
    "NCK1": [
        "NCK1_69K"
    ],
    "NCL": [
        "NCL_9K",
        "NCL_124K",
        "NCL_125K",
        "NCL_109K",
        "NCL_116K",
        "NCL_477K",
        "NCL_80K",
        "NCL_132K",
        "NCL_102K",
        "NCL_71K",
        "NCL_79K",
        "NCL_63K",
        "NCL_70K",
        "NCL_403K",
        "NCL_467K",
        "NCL_572K",
        "NCL_398K",
        "NCL_377K"
    ],
    "NCOA6": [
        "NCOA6_1822K"
    ],
    "NCOR1": [
        "NCOR1_1207K",
        "NCOR1_194K",
        "NCOR1_201K",
        "NCOR1_1287K",
        "NCOR1_1152K",
        "NCOR1_683K",
        "NCOR1_1404K",
        "NCOR1_2206K",
        "NCOR1_1244K"
    ],
    "NCOR2": [
        "NCOR2_335K",
        "NCOR2_1509K",
        "NCOR2_1265K",
        "NCOR2_1273K",
        "NCOR2_192K",
        "NCOR2_2069K",
        "NCOR2_1240K",
        "NCOR2_1210K",
        "NCOR2_1584K",
        "NCOR2_1578K",
        "NCOR2_2281K",
        "NCOR2_1447K",
        "NCOR2_2399K",
        "NCOR2_1308K",
        "NCOR2_1469K"
    ],
    "NECAP1": [
        "NECAP1_169K",
        "NECAP1_148K"
    ],
    "NEDD8": [
        "NEDD8_6K"
    ],
    "NELFA": [
        "NELFA_215K",
        "NELFA_429K"
    ],
    "NELFE": [
        "NELFE_95K"
    ],
    "NFATC2": [
        "NFATC2_482K"
    ],
    "NFATC2IP": [
        "NFATC2IP_224K"
    ],
    "NFIB": [
        "NFIB_270K"
    ],
    "NFIC": [
        "NFIC_280K"
    ],
    "NHEJ1": [
        "NHEJ1_288K"
    ],
    "NHLRC2": [
        "NHLRC2_596K"
    ],
    "NIFK": [
        "NIFK_198K",
        "NIFK_158K"
    ],
    "NIPBL": [
        "NIPBL_2566K",
        "NIPBL_2574K",
        "NIPBL_1369K",
        "NIPBL_1040K"
    ],
    "NKAP": [
        "NKAP_396K"
    ],
    "NME2": [
        "NME2_31K",
        "NME2_12K",
        "NME2_100K",
        "NME2_49K",
        "NME2_124K"
    ],
    "NMNAT1": [
        "NMNAT1_128K"
    ],
    "NOB1": [
        "NOB1_330K"
    ],
    "NOL6": [
        "NOL6_54K"
    ],
    "NOL7": [
        "NOL7_112K",
        "NOL7_210K",
        "NOL7_162K"
    ],
    "NOLC1": [
        "NOLC1_579K",
        "NOLC1_663K",
        "NOLC1_452K",
        "NOLC1_347K",
        "NOLC1_193K",
        "NOLC1_302K",
        "NOLC1_186K",
        "NOLC1_415K"
    ],
    "NONO": [
        "NONO_467K",
        "NONO_243K",
        "NONO_249K",
        "NONO_336K",
        "NONO_5K",
        "NONO_11K",
        "NONO_371K"
    ],
    "NOP14": [
        "NOP14_801K",
        "NOP14_809K"
    ],
    "NOP2": [
        "NOP2_91K",
        "NOP2_79K"
    ],
    "NOP56": [
        "NOP56_578K",
        "NOP56_589K",
        "NOP56_375K"
    ],
    "NOP58": [
        "NOP58_411K",
        "NOP58_444K",
        "NOP58_441K"
    ],
    "NOP9": [
        "NOP9_625K"
    ],
    "NOPCHAP1": [
        "NOPCHAP1_54K",
        "NOPCHAP1_51K"
    ],
    "NOSIP": [
        "NOSIP_6K"
    ],
    "NPEPL1": [
        "NPEPL1_272K"
    ],
    "NPM1": [
        "NPM1_27K",
        "NPM1_250K",
        "NPM1_257K",
        "NPM1_273K",
        "NPM1_248K",
        "NPM1_233K",
        "NPM1_141K",
        "NPM1_150K",
        "NPM1_223K",
        "NPM1_239K",
        "NPM1_267K"
    ],
    "NSD3": [
        "NSD3_477K"
    ],
    "NSF": [
        "NSF_105K"
    ],
    "NSFL1C": [
        "NSFL1C_251K",
        "NSFL1C_113K",
        "NSFL1C_139K"
    ],
    "NSRP1": [
        "NSRP1_14K"
    ],
    "NSUN2": [
        "NSUN2_508K",
        "NSUN2_445K"
    ],
    "NT5DC1": [
        "NT5DC1_356K"
    ],
    "NUCKS1": [
        "NUCKS1_184K",
        "NUCKS1_35K",
        "NUCKS1_188K",
        "NUCKS1_196K",
        "NUCKS1_175K",
        "NUCKS1_52K"
    ],
    "NUDC": [
        "NUDC_96K",
        "NUDC_315K"
    ],
    "NUDT21": [
        "NUDT21_23K"
    ],
    "NUDT9": [
        "NUDT9_74K"
    ],
    "NUFIP1": [
        "NUFIP1_277K"
    ],
    "NUFIP2": [
        "NUFIP2_152K"
    ],
    "NUMA1": [
        "NUMA1_1708K",
        "NUMA1_2005K",
        "NUMA1_1566K",
        "NUMA1_1573K",
        "NUMA1_2004K"
    ],
    "NUP133": [
        "NUP133_135K"
    ],
    "NUP50": [
        "NUP50_62K"
    ],
    "NUP98": [
        "NUP98_1040K",
        "NUP98_563K"
    ],
    "NUSAP1": [
        "NUSAP1_404K"
    ],
    "NVL": [
        "NVL_156K"
    ],
    "OCIAD1": [
        "OCIAD1_195K"
    ],
    "ODR4": [
        "ODR4_158K"
    ],
    "OGDH": [
        "OGDH_970K"
    ],
    "OGT": [
        "OGT_16K"
    ],
    "OLA1": [
        "OLA1_394K"
    ],
    "ORC2": [
        "ORC2_47K",
        "ORC2_108K"
    ],
    "ORC3": [
        "ORC3_523K"
    ],
    "ORC4": [
        "ORC4_7K"
    ],
    "OTUD4": [
        "OTUD4_249K"
    ],
    "OTUD7B": [
        "OTUD7B_505K"
    ],
    "OVOL1": [
        "OVOL1_202K"
    ],
    "OXCT1": [
        "OXCT1_446K",
        "OXCT1_176K"
    ],
    "P4HB": [
        "P4HB_309K",
        "P4HB_31K",
        "P4HB_71K",
        "P4HB_276K",
        "P4HB_283K",
        "P4HB_385K",
        "P4HB_271K",
        "P4HB_328K"
    ],
    "PA2G4": [
        "PA2G4_376K"
    ],
    "PABPC1": [
        "PABPC1_188K",
        "PABPC1_312K",
        "PABPC1_95K",
        "PABPC1_512K"
    ],
    "PABPN1L": [
        "PABPN1L_182K"
    ],
    "PACS1": [
        "PACS1_317K",
        "PACS1_885K",
        "PACS1_487K"
    ],
    "PAF1": [
        "PAF1_62K",
        "PAF1_119K"
    ],
    "PAFAH1B1": [
        "PAFAH1B1_88K"
    ],
    "PAICS": [
        "PAICS_11K",
        "PAICS_235K",
        "PAICS_47K"
    ],
    "PAK1IP1": [
        "PAK1IP1_371K",
        "PAK1IP1_374K"
    ],
    "PAK2": [
        "PAK2_52K",
        "PAK2_62K",
        "PAK2_191K"
    ],
    "PAPSS1": [
        "PAPSS1_9K"
    ],
    "PARK7": [
        "PARK7_148K",
        "PARK7_41K"
    ],
    "PARN": [
        "PARN_616K",
        "PARN_525K"
    ],
    "PARP1": [
        "PARP1_518K",
        "PARP1_498K",
        "PARP1_105K",
        "PARP1_512K",
        "PARP1_654K",
        "PARP1_97K"
    ],
    "PARP8": [
        "PARP8_305K"
    ],
    "PATZ1": [
        "PATZ1_353K"
    ],
    "PAWR": [
        "PAWR_227K"
    ],
    "PAXX": [
        "PAXX_191K",
        "PAXX_193K"
    ],
    "PCBP1": [
        "PCBP1_31K",
        "PCBP1_351K",
        "PCBP1_115K"
    ],
    "PCBP2": [
        "PCBP2_115K"
    ],
    "PCF11": [
        "PCF11_331K"
    ],
    "PCLAF": [
        "PCLAF_24K",
        "PCLAF_5K"
    ],
    "PCMT1": [
        "PCMT1_4K"
    ],
    "PCNA": [
        "PCNA_80K"
    ],
    "PCNP": [
        "PCNP_32K",
        "PCNP_89K",
        "PCNP_96K",
        "PCNP_150K",
        "PCNP_152K",
        "PCNP_81K",
        "PCNP_82K",
        "PCNP_70K",
        "PCNP_167K",
        "PCNP_64K",
        "PCNP_67K"
    ],
    "PCYT1A": [
        "PCYT1A_266K",
        "PCYT1A_238K",
        "PCYT1A_355K",
        "PCYT1A_8K",
        "PCYT1A_261K",
        "PCYT1A_254K"
    ],
    "PDAP1": [
        "PDAP1_164K",
        "PDAP1_172K",
        "PDAP1_95K",
        "PDAP1_132K",
        "PDAP1_137K",
        "PDAP1_126K"
    ],
    "PDCD5": [
        "PDCD5_110K",
        "PDCD5_105K"
    ],
    "PDIA3": [
        "PDIA3_289K",
        "PDIA3_130K",
        "PDIA3_75K",
        "PDIA3_129K"
    ],
    "PDIA4": [
        "PDIA4_245K"
    ],
    "PDLIM1": [
        "PDLIM1_246K"
    ],
    "PDLIM5": [
        "PDLIM5_415K"
    ],
    "PDLIM7": [
        "PDLIM7_93K"
    ],
    "PDS5A": [
        "PDS5A_1315K",
        "PDS5A_1318K",
        "PDS5A_1211K",
        "PDS5A_1294K",
        "PDS5A_1146K"
    ],
    "PDS5B": [
        "PDS5B_1309K",
        "PDS5B_1318K",
        "PDS5B_1244K",
        "PDS5B_1124K"
    ],
    "PEBP1": [
        "PEBP1_150K",
        "PEBP1_47K"
    ],
    "PELP1": [
        "PELP1_498K"
    ],
    "PES1": [
        "PES1_533K",
        "PES1_517K"
    ],
    "PFKL": [
        "PFKL_392K",
        "PFKL_677K",
        "PFKL_713K"
    ],
    "PFKM": [
        "PFKM_678K"
    ],
    "PFKP": [
        "PFKP_688K"
    ],
    "PFN1": [
        "PFN1_126K",
        "PFN1_105K",
        "PFN1_91K"
    ],
    "PGAM1": [
        "PGAM1_106K",
        "PGAM1_251K",
        "PGAM1_100K"
    ],
    "PGD": [
        "PGD_316K",
        "PGD_51K",
        "PGD_59K",
        "PGD_38K",
        "PGD_48K"
    ],
    "PGK1": [
        "PGK1_131K",
        "PGK1_41K",
        "PGK1_192K"
    ],
    "PGLS": [
        "PGLS_180K"
    ],
    "PHAX": [
        "PHAX_158K"
    ],
    "PHB": [
        "PHB_202K",
        "PHB_208K"
    ],
    "PHC2": [
        "PHC2_702K",
        "PHC2_689K",
        "PHC2_598K"
    ],
    "PHC3": [
        "PHC3_256K"
    ],
    "PHF10": [
        "PHF10_206K",
        "PHF10_365K",
        "PHF10_195K"
    ],
    "PHF2": [
        "PHF2_569K",
        "PHF2_606K"
    ],
    "PHF20L1": [
        "PHF20L1_280K"
    ],
    "PHF23": [
        "PHF23_187K",
        "PHF23_372K"
    ],
    "PHF3": [
        "PHF3_520K"
    ],
    "PHF6": [
        "PHF6_26K",
        "PHF6_173K"
    ],
    "PHGDH": [
        "PHGDH_21K",
        "PHGDH_8K",
        "PHGDH_58K"
    ],
    "PHIP": [
        "PHIP_1602K",
        "PHIP_1596K",
        "PHIP_1533K",
        "PHIP_1550K"
    ],
    "PHLDB2": [
        "PHLDB2_87K"
    ],
    "PIAS4": [
        "PIAS4_125K"
    ],
    "PIP4K2A": [
        "PIP4K2A_27K"
    ],
    "PIP4K2C": [
        "PIP4K2C_390K",
        "PIP4K2C_393K",
        "PIP4K2C_37K"
    ],
    "PKM": [
        "PKM_66K",
        "PKM_135K",
        "PKM_270K",
        "PKM_247K",
        "PKM_207K",
        "PKM_166K",
        "PKM_115K",
        "PKM_62K",
        "PKM_125K",
        "PKM_498K"
    ],
    "PKN2": [
        "PKN2_247K"
    ],
    "PLEC": [
        "PLEC_3027K",
        "PLEC_1175K",
        "PLEC_1438K",
        "PLEC_1725K",
        "PLEC_2452K",
        "PLEC_567K",
        "PLEC_1718K",
        "PLEC_2099K"
    ],
    "PLEKHA2": [
        "PLEKHA2_73K"
    ],
    "PLPBP": [
        "PLPBP_254K",
        "PLPBP_260K"
    ],
    "PML": [
        "PML_476K"
    ],
    "PMVK": [
        "PMVK_69K"
    ],
    "PNKP": [
        "PNKP_142K"
    ],
    "PNN": [
        "PNN_553K"
    ],
    "POGZ": [
        "POGZ_744K",
        "POGZ_883K",
        "POGZ_489K"
    ],
    "POLA2": [
        "POLA2_134K"
    ],
    "POLB": [
        "POLB_48K"
    ],
    "POLD2": [
        "POLD2_267K"
    ],
    "POLD3": [
        "POLD3_452K",
        "POLD3_292K"
    ],
    "POLDIP3": [
        "POLDIP3_223K",
        "POLDIP3_147K"
    ],
    "POLE4": [
        "POLE4_90K"
    ],
    "POLR1E": [
        "POLR1E_295K"
    ],
    "POLR1G": [
        "POLR1G_70K"
    ],
    "POP1": [
        "POP1_751K"
    ],
    "PPAN": [
        "PPAN_435K"
    ],
    "PPHLN1": [
        "PPHLN1_171K"
    ],
    "PPIA": [
        "PPIA_44K",
        "PPIA_49K",
        "PPIA_131K",
        "PPIA_133K",
        "PPIA_155K",
        "PPIA_125K",
        "PPIA_31K"
    ],
    "PPIB": [
        "PPIB_116K",
        "PPIB_209K",
        "PPIB_215K"
    ],
    "PPID": [
        "PPID_168K"
    ],
    "PPIG": [
        "PPIG_180K"
    ],
    "PPIL2": [
        "PPIL2_507K",
        "PPIL2_454K",
        "PPIL2_235K",
        "PPIL2_490K"
    ],
    "PPIL4": [
        "PPIL4_460K"
    ],
    "PPL": [
        "PPL_12K"
    ],
    "PPM1G": [
        "PPM1G_519K"
    ],
    "PPME1": [
        "PPME1_30K",
        "PPME1_6K"
    ],
    "PPP1CA": [
        "PPP1CA_305K",
        "PPP1CA_26K"
    ],
    "PPP1CB": [
        "PPP1CB_303K"
    ],
    "PPP1R10": [
        "PPP1R10_207K"
    ],
    "PPP1R11": [
        "PPP1R11_31K",
        "PPP1R11_59K"
    ],
    "PPP1R12A": [
        "PPP1R12A_532K"
    ],
    "PPP1R14B": [
        "PPP1R14B_140K",
        "PPP1R14B_59K"
    ],
    "PPP1R2": [
        "PPP1R2_12K",
        "PPP1R2_42K",
        "PPP1R2_145K",
        "PPP1R2_113K",
        "PPP1R2_18K"
    ],
    "PPP1R8": [
        "PPP1R8_234K"
    ],
    "PPP2R1A": [
        "PPP2R1A_188K"
    ],
    "PPP2R2A": [
        "PPP2R2A_405K"
    ],
    "PPP2R5C": [
        "PPP2R5C_496K"
    ],
    "PPP2R5D": [
        "PPP2R5D_73K",
        "PPP2R5D_82K",
        "PPP2R5D_572K"
    ],
    "PPP4R3A": [
        "PPP4R3A_733K"
    ],
    "PPP4R3B": [
        "PPP4R3B_765K"
    ],
    "PPWD1": [
        "PPWD1_65K"
    ],
    "PQBP1": [
        "PQBP1_189K",
        "PQBP1_223K",
        "PQBP1_167K"
    ],
    "PRC1": [
        "PRC1_484K"
    ],
    "PRCC": [
        "PRCC_250K",
        "PRCC_146K",
        "PRCC_479K",
        "PRCC_225K"
    ],
    "PRDM2": [
        "PRDM2_1625K"
    ],
    "PRDX1": [
        "PRDX1_35K",
        "PRDX1_197K",
        "PRDX1_190K",
        "PRDX1_192K",
        "PRDX1_7K"
    ],
    "PRDX2": [
        "PRDX2_26K",
        "PRDX2_196K"
    ],
    "PRDX6": [
        "PRDX6_56K",
        "PRDX6_209K"
    ],
    "PREX1": [
        "PREX1_607K",
        "PREX1_434K"
    ],
    "PRKAR2A": [
        "PRKAR2A_318K"
    ],
    "PRKCSH": [
        "PRKCSH_158K",
        "PRKCSH_166K",
        "PRKCSH_376K"
    ],
    "PRKDC": [
        "PRKDC_2694K",
        "PRKDC_2908K",
        "PRKDC_1057K"
    ],
    "PRKRIP1": [
        "PRKRIP1_126K",
        "PRKRIP1_117K"
    ],
    "PRMT1": [
        "PRMT1_145K"
    ],
    "PRMT5": [
        "PRMT5_240K"
    ],
    "PRMT6": [
        "PRMT6_8K"
    ],
    "PRPF19": [
        "PRPF19_179K"
    ],
    "PRPF3": [
        "PRPF3_103K",
        "PRPF3_337K",
        "PRPF3_282K",
        "PRPF3_328K"
    ],
    "PRPF31": [
        "PRPF31_422K",
        "PRPF31_417K",
        "PRPF31_430K"
    ],
    "PRPF38A": [
        "PRPF38A_7K"
    ],
    "PRPF38B": [
        "PRPF38B_105K"
    ],
    "PRPF4": [
        "PRPF4_53K",
        "PRPF4_45K",
        "PRPF4_15K"
    ],
    "PRPF6": [
        "PRPF6_146K",
        "PRPF6_137K",
        "PRPF6_178K"
    ],
    "PRPF8": [
        "PRPF8_50K",
        "PRPF8_36K"
    ],
    "PRR12": [
        "PRR12_1226K",
        "PRR12_27K"
    ],
    "PRRC1": [
        "PRRC1_269K"
    ],
    "PRRX1": [
        "PRRX1_160K",
        "PRRX1_31K"
    ],
    "PSIP1": [
        "PSIP1_143K",
        "PSIP1_407K",
        "PSIP1_189K",
        "PSIP1_304K"
    ],
    "PSMA1": [
        "PSMA1_61K",
        "PSMA1_243K",
        "PSMA1_115K"
    ],
    "PSMA3": [
        "PSMA3_57K"
    ],
    "PSMA6": [
        "PSMA6_171K",
        "PSMA6_181K",
        "PSMA6_45K"
    ],
    "PSMA7": [
        "PSMA7_52K"
    ],
    "PSMB5": [
        "PSMB5_91K"
    ],
    "PSMC1": [
        "PSMC1_24K"
    ],
    "PSMC2": [
        "PSMC2_116K"
    ],
    "PSMC5": [
        "PSMC5_55K",
        "PSMC5_88K"
    ],
    "PSMD1": [
        "PSMD1_838K"
    ],
    "PSMD12": [
        "PSMD12_301K",
        "PSMD12_419K"
    ],
    "PSMD3": [
        "PSMD3_315K",
        "PSMD3_503K"
    ],
    "PSMD4": [
        "PSMD4_74K"
    ],
    "PSMD6": [
        "PSMD6_372K",
        "PSMD6_371K",
        "PSMD6_130K"
    ],
    "PSMD7": [
        "PSMD7_180K"
    ],
    "PSMD9": [
        "PSMD9_123K"
    ],
    "PSME1": [
        "PSME1_190K"
    ],
    "PSME2": [
        "PSME2_180K",
        "PSME2_15K",
        "PSME2_156K"
    ],
    "PSME3IP1": [
        "PSME3IP1_151K",
        "PSME3IP1_158K",
        "PSME3IP1_135K",
        "PSME3IP1_144K",
        "PSME3IP1_146K"
    ],
    "PSMG1": [
        "PSMG1_264K",
        "PSMG1_55K"
    ],
    "PSPC1": [
        "PSPC1_8K",
        "PSPC1_519K",
        "PSPC1_14K"
    ],
    "PTBP1": [
        "PTBP1_137K",
        "PTBP1_410K"
    ],
    "PTBP2": [
        "PTBP2_411K"
    ],
    "PTGES3": [
        "PTGES3_33K"
    ],
    "PTPN11": [
        "PTPN11_538K"
    ],
    "PTPN2": [
        "PTPN2_364K"
    ],
    "PUF60": [
        "PUF60_454K",
        "PUF60_458K"
    ],
    "PUS1": [
        "PUS1_67K"
    ],
    "PUS7": [
        "PUS7_34K"
    ],
    "PWWP2A": [
        "PWWP2A_421K"
    ],
    "PYM1": [
        "PYM1_33K"
    ],
    "QPRT": [
        "QPRT_139K"
    ],
    "QRICH1": [
        "QRICH1_246K",
        "QRICH1_672K"
    ],
    "QSER1": [
        "QSER1_1654K",
        "QSER1_1479K"
    ],
    "RAB13": [
        "RAB13_3K"
    ],
    "RAB1A": [
        "RAB1A_132K"
    ],
    "RAB1B": [
        "RAB1B_116K",
        "RAB1B_122K"
    ],
    "RABL6": [
        "RABL6_7K"
    ],
    "RAC1": [
        "RAC1_128K"
    ],
    "RACGAP1": [
        "RACGAP1_199K",
        "RACGAP1_604K",
        "RACGAP1_404K"
    ],
    "RAD21": [
        "RAD21_323K"
    ],
    "RAI1": [
        "RAI1_1328K",
        "RAI1_1335K",
        "RAI1_83K",
        "RAI1_466K",
        "RAI1_1151K"
    ],
    "RALY": [
        "RALY_13K",
        "RALY_4K"
    ],
    "RAN": [
        "RAN_134K",
        "RAN_37K",
        "RAN_142K",
        "RAN_99K"
    ],
    "RANBP1": [
        "RANBP1_190K",
        "RANBP1_154K"
    ],
    "RANBP2": [
        "RANBP2_2165K",
        "RANBP2_1851K"
    ],
    "RB1": [
        "RB1_847K",
        "RB1_900K",
        "RB1_896K",
        "RB1_265K",
        "RB1_824K",
        "RB1_873K",
        "RB1_791K"
    ],
    "RBBP5": [
        "RBBP5_502K",
        "RBBP5_495K",
        "RBBP5_517K"
    ],
    "RBBP6": [
        "RBBP6_190K",
        "RBBP6_1350K",
        "RBBP6_85K"
    ],
    "RBM10": [
        "RBM10_699K",
        "RBM10_920K",
        "RBM10_464K",
        "RBM10_881K",
        "RBM10_837K",
        "RBM10_653K",
        "RBM10_646K"
    ],
    "RBM14": [
        "RBM14_600K",
        "RBM14_149K"
    ],
    "RBM15": [
        "RBM15_762K",
        "RBM15_102K"
    ],
    "RBM17": [
        "RBM17_41K",
        "RBM17_276K",
        "RBM17_269K",
        "RBM17_245K",
        "RBM17_34K",
        "RBM17_290K",
        "RBM17_33K",
        "RBM17_24K",
        "RBM17_58K",
        "RBM17_21K",
        "RBM17_46K"
    ],
    "RBM22": [
        "RBM22_149K"
    ],
    "RBM25": [
        "RBM25_739K",
        "RBM25_688K",
        "RBM25_711K"
    ],
    "RBM26": [
        "RBM26_524K",
        "RBM26_523K",
        "RBM26_705K"
    ],
    "RBM27": [
        "RBM27_852K",
        "RBM27_799K"
    ],
    "RBM28": [
        "RBM28_669K",
        "RBM28_746K",
        "RBM28_269K"
    ],
    "RBM33": [
        "RBM33_1061K"
    ],
    "RBM39": [
        "RBM39_111K",
        "RBM39_103K"
    ],
    "RBM6": [
        "RBM6_1019K"
    ],
    "RBMX": [
        "RBMX_217K"
    ],
    "RBP1": [
        "RBP1_32K",
        "RBP1_99K"
    ],
    "RBPJ": [
        "RBPJ_175K"
    ],
    "RCC2": [
        "RCC2_124K",
        "RCC2_77K"
    ],
    "RCOR1": [
        "RCOR1_365K",
        "RCOR1_14K",
        "RCOR1_285K",
        "RCOR1_381K",
        "RCOR1_7K",
        "RCOR1_242K"
    ],
    "RCOR2": [
        "RCOR2_7K"
    ],
    "RECQL": [
        "RECQL_637K",
        "RECQL_626K",
        "RECQL_625K"
    ],
    "RECQL5": [
        "RECQL5_743K"
    ],
    "REEP5": [
        "REEP5_176K"
    ],
    "RELB": [
        "RELB_233K"
    ],
    "RFC1": [
        "RFC1_318K",
        "RFC1_339K",
        "RFC1_5K",
        "RFC1_88K",
        "RFC1_306K"
    ],
    "RFC4": [
        "RFC4_18K"
    ],
    "RGS10": [
        "RGS10_12K",
        "RGS10_173K"
    ],
    "RIDA": [
        "RIDA_117K"
    ],
    "RIF1": [
        "RIF1_1014K",
        "RIF1_1027K"
    ],
    "RNASEH2B": [
        "RNASEH2B_250K",
        "RNASEH2B_247K",
        "RNASEH2B_304K"
    ],
    "RNF113A": [
        "RNF113A_139K",
        "RNF113A_69K"
    ],
    "RNF114": [
        "RNF114_126K"
    ],
    "RNGTT": [
        "RNGTT_220K"
    ],
    "RNMT": [
        "RNMT_128K",
        "RNMT_83K"
    ],
    "RNPS1": [
        "RNPS1_9K"
    ],
    "ROCK1": [
        "ROCK1_596K"
    ],
    "RPA1": [
        "RPA1_163K",
        "RPA1_167K",
        "RPA1_88K",
        "RPA1_267K"
    ],
    "RPF2": [
        "RPF2_47K"
    ],
    "RPL10": [
        "RPL10_121K"
    ],
    "RPL10A": [
        "RPL10A_130K",
        "RPL10A_106K"
    ],
    "RPL11": [
        "RPL11_85K",
        "RPL11_78K",
        "RPL11_67K",
        "RPL11_144K",
        "RPL11_52K"
    ],
    "RPL12": [
        "RPL12_54K"
    ],
    "RPL13": [
        "RPL13_200K",
        "RPL13_123K"
    ],
    "RPL13A": [
        "RPL13A_134K",
        "RPL13A_191K",
        "RPL13A_159K"
    ],
    "RPL14": [
        "RPL14_85K",
        "RPL14_103K",
        "RPL14_204K",
        "RPL14_187K",
        "RPL14_177K",
        "RPL14_132K"
    ],
    "RPL15": [
        "RPL15_14K"
    ],
    "RPL17": [
        "RPL17_55K",
        "RPL17_167K",
        "RPL17_37K",
        "RPL17_49K"
    ],
    "RPL18": [
        "RPL18_49K"
    ],
    "RPL18A": [
        "RPL18A_11K",
        "RPL18A_143K",
        "RPL18A_136K"
    ],
    "RPL19": [
        "RPL19_186K",
        "RPL19_153K",
        "RPL19_128K"
    ],
    "RPL22": [
        "RPL22_80K",
        "RPL22_107K"
    ],
    "RPL23": [
        "RPL23_113K",
        "RPL23_13K",
        "RPL23_75K"
    ],
    "RPL23A": [
        "RPL23A_30K",
        "RPL23A_14K",
        "RPL23A_7K",
        "RPL23A_115K",
        "RPL23A_70K",
        "RPL23A_134K"
    ],
    "RPL24": [
        "RPL24_147K",
        "RPL24_141K",
        "RPL24_131K"
    ],
    "RPL26": [
        "RPL26_63K",
        "RPL26_69K",
        "RPL26_134K",
        "RPL26_136K",
        "RPL26_51K"
    ],
    "RPL26L1": [
        "RPL26L1_136K"
    ],
    "RPL27": [
        "RPL27_98K",
        "RPL27_93K"
    ],
    "RPL27A": [
        "RPL27A_119K",
        "RPL27A_94K"
    ],
    "RPL28": [
        "RPL28_47K"
    ],
    "RPL29": [
        "RPL29_73K",
        "RPL29_79K",
        "RPL29_149K",
        "RPL29_134K",
        "RPL29_103K",
        "RPL29_33K"
    ],
    "RPL3": [
        "RPL3_66K",
        "RPL3_373K",
        "RPL3_229K",
        "RPL3_366K",
        "RPL3_286K",
        "RPL3_349K",
        "RPL3_356K",
        "RPL3_250K",
        "RPL3_136K",
        "RPL3_155K",
        "RPL3_300K"
    ],
    "RPL30": [
        "RPL30_9K",
        "RPL30_26K",
        "RPL30_32K"
    ],
    "RPL31": [
        "RPL31_75K",
        "RPL31_39K"
    ],
    "RPL32": [
        "RPL32_76K"
    ],
    "RPL34": [
        "RPL34_85K",
        "RPL34_19K",
        "RPL34_108K"
    ],
    "RPL35": [
        "RPL35_13K",
        "RPL35_97K",
        "RPL35_79K"
    ],
    "RPL35A": [
        "RPL35A_45K",
        "RPL35A_95K"
    ],
    "RPL36": [
        "RPL36_13K"
    ],
    "RPL36A": [
        "RPL36A_38K",
        "RPL36A_30K"
    ],
    "RPL37": [
        "RPL37_31K"
    ],
    "RPL37A": [
        "RPL37A_28K",
        "RPL37A_13K"
    ],
    "RPL4": [
        "RPL4_364K",
        "RPL4_274K",
        "RPL4_20K",
        "RPL4_294K",
        "RPL4_175K",
        "RPL4_14K",
        "RPL4_353K"
    ],
    "RPL5": [
        "RPL5_27K",
        "RPL5_255K",
        "RPL5_221K",
        "RPL5_41K",
        "RPL5_43K",
        "RPL5_276K",
        "RPL5_48K",
        "RPL5_270K",
        "RPL5_158K",
        "RPL5_220K"
    ],
    "RPL6": [
        "RPL6_260K",
        "RPL6_87K",
        "RPL6_94K",
        "RPL6_239K",
        "RPL6_218K",
        "RPL6_210K",
        "RPL6_192K"
    ],
    "RPL7": [
        "RPL7_77K",
        "RPL7_9K",
        "RPL7_223K",
        "RPL7_156K"
    ],
    "RPL7A": [
        "RPL7A_125K",
        "RPL7A_197K",
        "RPL7A_11K",
        "RPL7A_20K",
        "RPL7A_26K",
        "RPL7A_48K"
    ],
    "RPL8": [
        "RPL8_181K",
        "RPL8_10K",
        "RPL8_149K"
    ],
    "RPL9": [
        "RPL9_65K",
        "RPL9_174K",
        "RPL9_121K",
        "RPL9_28K"
    ],
    "RPN1": [
        "RPN1_579K",
        "RPN1_538K"
    ],
    "RPP30": [
        "RPP30_262K"
    ],
    "RPP38": [
        "RPP38_263K"
    ],
    "RPRD2": [
        "RPRD2_150K",
        "RPRD2_177K"
    ],
    "RPS10": [
        "RPS10_139K",
        "RPS10_107K"
    ],
    "RPS11": [
        "RPS11_12K",
        "RPS11_58K",
        "RPS11_144K",
        "RPS11_79K",
        "RPS11_45K",
        "RPS11_48K",
        "RPS11_38K"
    ],
    "RPS12": [
        "RPS12_102K"
    ],
    "RPS13": [
        "RPS13_34K"
    ],
    "RPS14": [
        "RPS14_106K"
    ],
    "RPS15": [
        "RPS15_52K"
    ],
    "RPS15A": [
        "RPS15A_84K"
    ],
    "RPS16": [
        "RPS16_131K",
        "RPS16_4K"
    ],
    "RPS17": [
        "RPS17_44K",
        "RPS17_19K"
    ],
    "RPS18": [
        "RPS18_54K"
    ],
    "RPS19": [
        "RPS19_77K",
        "RPS19_143K",
        "RPS19_7K",
        "RPS19_38K"
    ],
    "RPS2": [
        "RPS2_211K",
        "RPS2_114K"
    ],
    "RPS20": [
        "RPS20_8K"
    ],
    "RPS21": [
        "RPS21_74K"
    ],
    "RPS23": [
        "RPS23_37K",
        "RPS23_48K",
        "RPS23_54K",
        "RPS23_21K",
        "RPS23_29K"
    ],
    "RPS24": [
        "RPS24_21K"
    ],
    "RPS25": [
        "RPS25_60K",
        "RPS25_43K",
        "RPS25_66K"
    ],
    "RPS27": [
        "RPS27_5K"
    ],
    "RPS27A": [
        "RPS27A_104K",
        "RPS27A_48K",
        "RPS27A_6K",
        "RPS27A_27K"
    ],
    "RPS28": [
        "RPS28_10K"
    ],
    "RPS29": [
        "RPS29_13K"
    ],
    "RPS3": [
        "RPS3_75K",
        "RPS3_10K",
        "RPS3_62K",
        "RPS3_108K"
    ],
    "RPS3A": [
        "RPS3A_249K",
        "RPS3A_182K",
        "RPS3A_187K",
        "RPS3A_85K",
        "RPS3A_63K",
        "RPS3A_220K",
        "RPS3A_222K",
        "RPS3A_152K",
        "RPS3A_46K",
        "RPS3A_56K"
    ],
    "RPS4X": [
        "RPS4X_233K",
        "RPS4X_53K",
        "RPS4X_62K",
        "RPS4X_16K"
    ],
    "RPS5": [
        "RPS5_63K",
        "RPS5_47K"
    ],
    "RPS6": [
        "RPS6_143K",
        "RPS6_149K",
        "RPS6_203K"
    ],
    "RPS6KA4": [
        "RPS6KA4_759K",
        "RPS6KA4_729K"
    ],
    "RPS6KB1": [
        "RPS6KB1_141K",
        "RPS6KB1_431K",
        "RPS6KB1_508K"
    ],
    "RPS7": [
        "RPS7_155K",
        "RPS7_74K",
        "RPS7_178K",
        "RPS7_147K"
    ],
    "RPS8": [
        "RPS8_128K",
        "RPS8_37K"
    ],
    "RPS9": [
        "RPS9_66K",
        "RPS9_139K",
        "RPS9_11K",
        "RPS9_47K"
    ],
    "RPSA": [
        "RPSA_42K"
    ],
    "RRBP1": [
        "RRBP1_1159K",
        "RRBP1_1092K"
    ],
    "RREB1": [
        "RREB1_63K"
    ],
    "RRP1": [
        "RRP1_446K"
    ],
    "RRP12": [
        "RRP12_1226K",
        "RRP12_14K",
        "RRP12_1274K",
        "RRP12_1268K",
        "RRP12_6K"
    ],
    "RRP15": [
        "RRP15_200K",
        "RRP15_208K",
        "RRP15_114K"
    ],
    "RRP1B": [
        "RRP1B_314K"
    ],
    "RRP7BP": [
        "RRP7BP_73K"
    ],
    "RRP8": [
        "RRP8_78K"
    ],
    "RSF1": [
        "RSF1_323K",
        "RSF1_405K",
        "RSF1_381K",
        "RSF1_787K",
        "RSF1_1004K",
        "RSF1_456K"
    ],
    "RSL1D1": [
        "RSL1D1_468K",
        "RSL1D1_408K",
        "RSL1D1_461K"
    ],
    "RSRC2": [
        "RSRC2_367K",
        "RSRC2_362K"
    ],
    "RTF1": [
        "RTF1_685K",
        "RTF1_504K",
        "RTF1_555K"
    ],
    "RTF2": [
        "RTF2_10K",
        "RTF2_16K",
        "RTF2_245K",
        "RTF2_224K"
    ],
    "RTKN": [
        "RTKN_216K"
    ],
    "RYBP": [
        "RYBP_104K"
    ],
    "S100A10": [
        "S100A10_57K"
    ],
    "S100A11": [
        "S100A11_3K",
        "S100A11_55K"
    ],
    "S100A16": [
        "S100A16_30K"
    ],
    "S100A4": [
        "S100A4_48K"
    ],
    "S100A6": [
        "S100A6_40K",
        "S100A6_47K",
        "S100A6_35K"
    ],
    "SAE1": [
        "SAE1_198K",
        "SAE1_183K",
        "SAE1_195K"
    ],
    "SAFB": [
        "SAFB_578K",
        "SAFB_570K"
    ],
    "SAFB2": [
        "SAFB2_395K"
    ],
    "SAP130": [
        "SAP130_981K"
    ],
    "SAP30": [
        "SAP30_91K"
    ],
    "SAP30BP": [
        "SAP30BP_228K",
        "SAP30BP_137K",
        "SAP30BP_220K",
        "SAP30BP_304K"
    ],
    "SARNP": [
        "SARNP_10K",
        "SARNP_119K",
        "SARNP_17K",
        "SARNP_92K"
    ],
    "SART1": [
        "SART1_302K",
        "SART1_666K",
        "SART1_657K",
        "SART1_183K"
    ],
    "SBDS": [
        "SBDS_98K"
    ],
    "SCAF1": [
        "SCAF1_1254K"
    ],
    "SCAF11": [
        "SCAF11_950K"
    ],
    "SCIN": [
        "SCIN_364K"
    ],
    "SDHA": [
        "SDHA_179K"
    ],
    "SEC22B": [
        "SEC22B_124K"
    ],
    "SELENOH": [
        "SELENOH_9K"
    ],
    "SENP3": [
        "SENP3_43K"
    ],
    "SEPTIN5": [
        "SEPTIN5_10K"
    ],
    "SEPTIN9": [
        "SEPTIN9_62K",
        "SEPTIN9_262K",
        "SEPTIN9_326K",
        "SEPTIN9_99K",
        "SEPTIN9_186K"
    ],
    "SERBP1": [
        "SERBP1_102K",
        "SERBP1_327K",
        "SERBP1_92K",
        "SERBP1_320K",
        "SERBP1_122K",
        "SERBP1_68K"
    ],
    "SERPINH1": [
        "SERPINH1_300K",
        "SERPINH1_287K",
        "SERPINH1_190K"
    ],
    "SET": [
        "SET_15K",
        "SET_35K",
        "SET_13K",
        "SET_189K"
    ],
    "SETD2": [
        "SETD2_37K"
    ],
    "SF1": [
        "SF1_15K",
        "SF1_306K"
    ],
    "SF3A1": [
        "SF3A1_424K"
    ],
    "SF3A2": [
        "SF3A2_76K",
        "SF3A2_10K"
    ],
    "SF3A3": [
        "SF3A3_303K"
    ],
    "SF3B1": [
        "SF3B1_333K",
        "SF3B1_6K",
        "SF3B1_214K",
        "SF3B1_146K"
    ],
    "SF3B2": [
        "SF3B2_870K"
    ],
    "SF3B6": [
        "SF3B6_7K"
    ],
    "SFN": [
        "SFN_11K",
        "SFN_140K"
    ],
    "SFPQ": [
        "SFPQ_703K",
        "SFPQ_211K",
        "SFPQ_421K",
        "SFPQ_559K",
        "SFPQ_232K",
        "SFPQ_413K"
    ],
    "SH3BGRL": [
        "SH3BGRL_17K"
    ],
    "SH3GL1": [
        "SH3GL1_20K",
        "SH3GL1_76K",
        "SH3GL1_12K"
    ],
    "SH3KBP1": [
        "SH3KBP1_225K",
        "SH3KBP1_535K",
        "SH3KBP1_211K"
    ],
    "SHC1": [
        "SHC1_321K"
    ],
    "SHMT2": [
        "SHMT2_464K",
        "SHMT2_103K"
    ],
    "SIN3A": [
        "SIN3A_535K",
        "SIN3A_1170K",
        "SIN3A_439K",
        "SIN3A_443K",
        "SIN3A_448K",
        "SIN3A_602K",
        "SIN3A_865K"
    ],
    "SIN3B": [
        "SIN3B_292K"
    ],
    "SINHCAF": [
        "SINHCAF_110K"
    ],
    "SKP1": [
        "SKP1_155K"
    ],
    "SLC25A24": [
        "SLC25A24_437K",
        "SLC25A24_320K"
    ],
    "SLC25A3": [
        "SLC25A3_295K"
    ],
    "SLC25A5": [
        "SLC25A5_163K",
        "SLC25A5_166K",
        "SLC25A5_147K",
        "SLC25A5_105K",
        "SLC25A5_33K",
        "SLC25A5_96K"
    ],
    "SLC25A6": [
        "SLC25A6_147K"
    ],
    "SLC27A3": [
        "SLC27A3_635K"
    ],
    "SLC27A4": [
        "SLC27A4_595K"
    ],
    "SLC3A2": [
        "SLC3A2_298K",
        "SLC3A2_166K",
        "SLC3A2_266K",
        "SLC3A2_147K",
        "SLC3A2_255K",
        "SLC3A2_257K"
    ],
    "SLC4A1AP": [
        "SLC4A1AP_297K",
        "SLC4A1AP_88K",
        "SLC4A1AP_757K",
        "SLC4A1AP_737K"
    ],
    "SLC7A5": [
        "SLC7A5_19K"
    ],
    "SLC9A3R1": [
        "SLC9A3R1_34K",
        "SLC9A3R1_172K"
    ],
    "SLK": [
        "SLK_11K"
    ],
    "SLTM": [
        "SLTM_803K",
        "SLTM_821K"
    ],
    "SLU7": [
        "SLU7_114K",
        "SLU7_527K"
    ],
    "SMAP": [
        "SMAP_91K",
        "SMAP_62K"
    ],
    "SMARCA4": [
        "SMARCA4_1131K"
    ],
    "SMARCA5": [
        "SMARCA5_945K",
        "SMARCA5_739K",
        "SMARCA5_1036K",
        "SMARCA5_694K",
        "SMARCA5_119K",
        "SMARCA5_929K"
    ],
    "SMARCAD1": [
        "SMARCAD1_346K"
    ],
    "SMARCC1": [
        "SMARCC1_882K",
        "SMARCC1_354K",
        "SMARCC1_346K"
    ],
    "SMARCC2": [
        "SMARCC2_318K",
        "SMARCC2_326K"
    ],
    "SMC1A": [
        "SMC1A_190K"
    ],
    "SMC3": [
        "SMC3_106K",
        "SMC3_1105K"
    ],
    "SMC5": [
        "SMC5_31K"
    ],
    "SMCHD1": [
        "SMCHD1_1987K"
    ],
    "SMN1": [
        "SMN1_83K"
    ],
    "SMTN": [
        "SMTN_757K"
    ],
    "SMYD5": [
        "SMYD5_34K"
    ],
    "SNRNP40": [
        "SNRNP40_8K",
        "SNRNP40_18K",
        "SNRNP40_270K"
    ],
    "SNRPA": [
        "SNRPA_96K"
    ],
    "SNRPA1": [
        "SNRPA1_172K",
        "SNRPA1_193K",
        "SNRPA1_221K",
        "SNRPA1_179K",
        "SNRPA1_191K"
    ],
    "SNRPB2": [
        "SNRPB2_111K",
        "SNRPB2_85K",
        "SNRPB2_93K"
    ],
    "SNRPG": [
        "SNRPG_3K"
    ],
    "SNRPN": [
        "SNRPN_8K"
    ],
    "SNW1": [
        "SNW1_170K",
        "SNW1_476K",
        "SNW1_266K",
        "SNW1_97K",
        "SNW1_81K",
        "SNW1_153K",
        "SNW1_115K"
    ],
    "SNX1": [
        "SNX1_290K"
    ],
    "SNX2": [
        "SNX2_287K"
    ],
    "SNX6": [
        "SNX6_183K"
    ],
    "SNX9": [
        "SNX9_207K"
    ],
    "SOD1": [
        "SOD1_129K"
    ],
    "SP3": [
        "SP3_634K"
    ],
    "SPAG7": [
        "SPAG7_166K",
        "SPAG7_173K",
        "SPAG7_177K",
        "SPAG7_197K"
    ],
    "SPART": [
        "SPART_481K",
        "SPART_519K"
    ],
    "SPEN": [
        "SPEN_931K"
    ],
    "SPIN1": [
        "SPIN1_44K",
        "SPIN1_7K"
    ],
    "SPTBN1": [
        "SPTBN1_1981K"
    ],
    "SPTLC1": [
        "SPTLC1_230K"
    ],
    "SRBD1": [
        "SRBD1_9K",
        "SRBD1_69K",
        "SRBD1_112K",
        "SRBD1_104K"
    ],
    "SREK1": [
        "SREK1_453K"
    ],
    "SRFBP1": [
        "SRFBP1_190K"
    ],
    "SRP14": [
        "SRP14_74K",
        "SRP14_43K"
    ],
    "SRP72": [
        "SRP72_383K"
    ],
    "SRRM1": [
        "SRRM1_735K",
        "SRRM1_459K",
        "SRRM1_29K"
    ],
    "SRRM2": [
        "SRRM2_920K"
    ],
    "SRRT": [
        "SRRT_78K"
    ],
    "SRSF1": [
        "SRSF1_30K"
    ],
    "SRSF10": [
        "SRSF10_218K"
    ],
    "SRSF5": [
        "SRSF5_25K"
    ],
    "SRSF6": [
        "SRSF6_101K"
    ],
    "SS18": [
        "SS18_13K"
    ],
    "SS18L1": [
        "SS18L1_13K"
    ],
    "SSB": [
        "SSB_354K",
        "SSB_328K",
        "SSB_317K"
    ],
    "SSBP3": [
        "SSBP3_6K"
    ],
    "SSH3": [
        "SSH3_598K"
    ],
    "SSRP1": [
        "SSRP1_534K",
        "SSRP1_661K"
    ],
    "STAT1": [
        "STAT1_193K"
    ],
    "STIP1": [
        "STIP1_442K",
        "STIP1_395K",
        "STIP1_246K",
        "STIP1_284K",
        "STIP1_388K",
        "STIP1_78K",
        "STIP1_317K"
    ],
    "STMN1": [
        "STMN1_128K",
        "STMN1_52K",
        "STMN1_119K",
        "STMN1_80K",
        "STMN1_43K",
        "STMN1_62K",
        "STMN1_100K",
        "STMN1_137K"
    ],
    "STOML2": [
        "STOML2_221K",
        "STOML2_145K"
    ],
    "STT3B": [
        "STT3B_513K"
    ],
    "STXBP1": [
        "STXBP1_526K"
    ],
    "SUB1": [
        "SUB1_53K",
        "SUB1_23K",
        "SUB1_29K",
        "SUB1_38K"
    ],
    "SUGP1": [
        "SUGP1_380K"
    ],
    "SUGP2": [
        "SUGP2_243K"
    ],
    "SUMO2": [
        "SUMO2_42K",
        "SUMO2_7K",
        "SUMO2_11K"
    ],
    "SUMO3": [
        "SUMO3_11K",
        "SUMO3_7K"
    ],
    "SUPT16H": [
        "SUPT16H_504K",
        "SUPT16H_497K"
    ],
    "SUPT5H": [
        "SUPT5H_143K"
    ],
    "SUZ12": [
        "SUZ12_732K"
    ],
    "SYMPK": [
        "SYMPK_490K"
    ],
    "SYNCRIP": [
        "SYNCRIP_576K",
        "SYNCRIP_566K",
        "SYNCRIP_256K"
    ],
    "SYTL2": [
        "SYTL2_243K"
    ],
    "SZRD1": [
        "SZRD1_86K"
    ],
    "TAF3": [
        "TAF3_776K"
    ],
    "TAF4": [
        "TAF4_817K"
    ],
    "TAGLN2": [
        "TAGLN2_17K",
        "TAGLN2_79K"
    ],
    "TALDO1": [
        "TALDO1_286K",
        "TALDO1_321K",
        "TALDO1_71K",
        "TALDO1_81K",
        "TALDO1_7K",
        "TALDO1_219K"
    ],
    "TARDBP": [
        "TARDBP_84K",
        "TARDBP_95K"
    ],
    "TASP1": [
        "TASP1_24K",
        "TASP1_217K"
    ],
    "TBCA": [
        "TBCA_51K",
        "TBCA_52K"
    ],
    "TBCB": [
        "TBCB_106K"
    ],
    "TCEA1": [
        "TCEA1_252K",
        "TCEA1_19K",
        "TCEA1_242K"
    ],
    "TCEAL1": [
        "TCEAL1_96K"
    ],
    "TCEAL4": [
        "TCEAL4_132K"
    ],
    "TCF3": [
        "TCF3_614K"
    ],
    "TCOF1": [
        "TCOF1_308K",
        "TCOF1_313K",
        "TCOF1_732K",
        "TCOF1_363K",
        "TCOF1_367K",
        "TCOF1_803K",
        "TCOF1_811K",
        "TCOF1_296K",
        "TCOF1_393K",
        "TCOF1_400K",
        "TCOF1_322K",
        "TCOF1_725K",
        "TCOF1_591K",
        "TCOF1_820K",
        "TCOF1_1034K",
        "TCOF1_642K",
        "TCOF1_74K",
        "TCOF1_668K",
        "TCOF1_1065K",
        "TCOF1_1129K",
        "TCOF1_1064K",
        "TCOF1_458K",
        "TCOF1_655K",
        "TCOF1_432K",
        "TCOF1_716K",
        "TCOF1_155K"
    ],
    "TDP1": [
        "TDP1_53K"
    ],
    "TEAD1": [
        "TEAD1_108K"
    ],
    "TERF2IP": [
        "TERF2IP_208K"
    ],
    "TES": [
        "TES_9K",
        "TES_80K",
        "TES_101K",
        "TES_183K"
    ],
    "TFAP2C": [
        "TFAP2C_195K"
    ],
    "TFIP11": [
        "TFIP11_187K",
        "TFIP11_159K",
        "TFIP11_241K"
    ],
    "THRAP3": [
        "THRAP3_876K",
        "THRAP3_346K",
        "THRAP3_375K",
        "THRAP3_387K",
        "THRAP3_705K",
        "THRAP3_455K",
        "THRAP3_461K",
        "THRAP3_519K",
        "THRAP3_486K",
        "THRAP3_879K",
        "THRAP3_551K",
        "THRAP3_252K",
        "THRAP3_921K",
        "THRAP3_527K",
        "THRAP3_711K"
    ],
    "THUMPD1": [
        "THUMPD1_15K",
        "THUMPD1_26K",
        "THUMPD1_19K",
        "THUMPD1_272K"
    ],
    "THYN1": [
        "THYN1_16K",
        "THYN1_24K"
    ],
    "TIA1": [
        "TIA1_89K"
    ],
    "TIMELESS": [
        "TIMELESS_1196K",
        "TIMELESS_313K"
    ],
    "TJP1": [
        "TJP1_194K"
    ],
    "TKT": [
        "TKT_232K",
        "TKT_241K",
        "TKT_319K",
        "TKT_102K",
        "TKT_543K",
        "TKT_16K",
        "TKT_6K"
    ],
    "TLE3": [
        "TLE3_309K",
        "TLE3_316K",
        "TLE3_225K",
        "TLE3_281K"
    ],
    "TLK2": [
        "TLK2_66K"
    ],
    "TLN1": [
        "TLN1_428K"
    ],
    "TMA16": [
        "TMA16_23K"
    ],
    "TMA7": [
        "TMA7_50K",
        "TMA7_59K",
        "TMA7_44K"
    ],
    "TMPO": [
        "TMPO_248K",
        "TMPO_667K",
        "TMPO_356K",
        "TMPO_207K",
        "TMPO_213K",
        "TMPO_393K"
    ],
    "TNKS1BP1": [
        "TNKS1BP1_1641K"
    ],
    "TOM1L1": [
        "TOM1L1_5K"
    ],
    "TOMM20": [
        "TOMM20_56K"
    ],
    "TOMM70": [
        "TOMM70_359K"
    ],
    "TOP1": [
        "TOP1_150K",
        "TOP1_137K",
        "TOP1_164K",
        "TOP1_172K",
        "TOP1_23K",
        "TOP1_642K"
    ],
    "TOP2A": [
        "TOP2A_1484K",
        "TOP2A_1276K",
        "TOP2A_614K"
    ],
    "TOP2B": [
        "TOP2B_1214K",
        "TOP2B_1548K",
        "TOP2B_1227K",
        "TOP2B_367K",
        "TOP2B_1490K",
        "TOP2B_1495K"
    ],
    "TP53BP1": [
        "TP53BP1_1669K"
    ],
    "TPD52L1": [
        "TPD52L1_123K"
    ],
    "TPD52L2": [
        "TPD52L2_128K"
    ],
    "TPI1": [
        "TPI1_142K",
        "TPI1_149K",
        "TPI1_188K",
        "TPI1_156K"
    ],
    "TPM1": [
        "TPM1_213K",
        "TPM1_152K"
    ],
    "TPM4": [
        "TPM4_116K",
        "TPM4_11K",
        "TPM4_44K",
        "TPM4_13K",
        "TPM4_169K",
        "TPM4_177K"
    ],
    "TPR": [
        "TPR_1648K",
        "TPR_1563K",
        "TPR_1690K"
    ],
    "TPX2": [
        "TPX2_375K",
        "TPX2_714K",
        "TPX2_237K",
        "TPX2_720K",
        "TPX2_362K"
    ],
    "TRA2A": [
        "TRA2A_198K"
    ],
    "TRA2B": [
        "TRA2B_197K"
    ],
    "TRERF1": [
        "TRERF1_134K"
    ],
    "TRIM24": [
        "TRIM24_1041K"
    ],
    "TRIM25": [
        "TRIM25_391K"
    ],
    "TRIM28": [
        "TRIM28_188K"
    ],
    "TRIM33": [
        "TRIM33_950K",
        "TRIM33_953K",
        "TRIM33_1118K",
        "TRIM33_763K",
        "TRIM33_769K"
    ],
    "TRIP12": [
        "TRIP12_1001K"
    ],
    "TRIR": [
        "TRIR_118K",
        "TRIR_106K",
        "TRIR_128K",
        "TRIR_146K"
    ],
    "TRMT6": [
        "TRMT6_145K"
    ],
    "TRPC5": [
        "TRPC5_795K"
    ],
    "TRPS1": [
        "TRPS1_76K",
        "TRPS1_363K",
        "TRPS1_965K",
        "TRPS1_381K",
        "TRPS1_1030K",
        "TRPS1_879K",
        "TRPS1_497K"
    ],
    "TSEN54": [
        "TSEN54_215K"
    ],
    "TSN": [
        "TSN_187K"
    ],
    "TSNAX": [
        "TSNAX_14K"
    ],
    "TSPYL5": [
        "TSPYL5_108K"
    ],
    "TSR1": [
        "TSR1_38K",
        "TSR1_10K"
    ],
    "TSSC4": [
        "TSSC4_234K"
    ],
    "TTC9": [
        "TTC9_4K"
    ],
    "TUBA1A": [
        "TUBA1A_336K",
        "TUBA1A_401K",
        "TUBA1A_326K"
    ],
    "TUFM": [
        "TUFM_88K",
        "TUFM_91K"
    ],
    "TWF1": [
        "TWF1_135K"
    ],
    "TXN": [
        "TXN_85K",
        "TXN_94K"
    ],
    "TXNDC9": [
        "TXNDC9_208K",
        "TXNDC9_201K"
    ],
    "TXNRD1": [
        "TXNRD1_129K"
    ],
    "U2AF2": [
        "U2AF2_70K"
    ],
    "U2SURP": [
        "U2SURP_88K",
        "U2SURP_832K",
        "U2SURP_156K",
        "U2SURP_755K",
        "U2SURP_201K",
        "U2SURP_80K"
    ],
    "UBA1": [
        "UBA1_593K",
        "UBA1_528K"
    ],
    "UBA2": [
        "UBA2_613K"
    ],
    "UBE2E1": [
        "UBE2E1_43K"
    ],
    "UBE2I": [
        "UBE2I_18K"
    ],
    "UBE2K": [
        "UBE2K_18K"
    ],
    "UBE2M": [
        "UBE2M_8K"
    ],
    "UBE2N": [
        "UBE2N_92K"
    ],
    "UBE2T": [
        "UBE2T_182K",
        "UBE2T_180K"
    ],
    "UBE2V1": [
        "UBE2V1_10K"
    ],
    "UBE3C": [
        "UBE3C_22K",
        "UBE3C_25K"
    ],
    "UBTF": [
        "UBTF_284K",
        "UBTF_216K"
    ],
    "UBXN1": [
        "UBXN1_154K"
    ],
    "UGDH": [
        "UGDH_107K",
        "UGDH_490K"
    ],
    "UIMC1": [
        "UIMC1_31K"
    ],
    "UNC45A": [
        "UNC45A_279K"
    ],
    "UNG": [
        "UNG_78K"
    ],
    "UPF1": [
        "UPF1_929K"
    ],
    "UQCRC2": [
        "UQCRC2_430K"
    ],
    "USP10": [
        "USP10_662K"
    ],
    "USP14": [
        "USP14_49K"
    ],
    "USP22": [
        "USP22_166K"
    ],
    "USP3": [
        "USP3_135K",
        "USP3_145K"
    ],
    "USP7": [
        "USP7_1096K"
    ],
    "UTP20": [
        "UTP20_2510K"
    ],
    "UTP23": [
        "UTP23_209K",
        "UTP23_198K"
    ],
    "UTP3": [
        "UTP3_417K",
        "UTP3_236K"
    ],
    "UTRN": [
        "UTRN_1497K"
    ],
    "VAPA": [
        "VAPA_205K"
    ],
    "VAPB": [
        "VAPB_118K",
        "VAPB_147K",
        "VAPB_200K"
    ],
    "VARS1": [
        "VARS1_246K"
    ],
    "VASP": [
        "VASP_240K"
    ],
    "VAV2": [
        "VAV2_757K"
    ],
    "VCL": [
        "VCL_417K",
        "VCL_219K"
    ],
    "VCP": [
        "VCP_505K",
        "VCP_211K"
    ],
    "VDAC1": [
        "VDAC1_61K"
    ],
    "VIM": [
        "VIM_188K",
        "VIM_120K",
        "VIM_168K",
        "VIM_294K",
        "VIM_445K",
        "VIM_104K"
    ],
    "VTA1": [
        "VTA1_52K"
    ],
    "VWF": [
        "VWF_1720K"
    ],
    "WAPL": [
        "WAPL_408K",
        "WAPL_597K",
        "WAPL_591K",
        "WAPL_27K"
    ],
    "WBP11": [
        "WBP11_614K",
        "WBP11_556K",
        "WBP11_590K",
        "WBP11_316K",
        "WBP11_599K",
        "WBP11_610K",
        "WBP11_545K",
        "WBP11_13K"
    ],
    "WBP4": [
        "WBP4_290K",
        "WBP4_274K"
    ],
    "WDHD1": [
        "WDHD1_941K",
        "WDHD1_915K"
    ],
    "WDR12": [
        "WDR12_239K"
    ],
    "WDR17": [
        "WDR17_1248K"
    ],
    "WDR33": [
        "WDR33_1044K"
    ],
    "WDR36": [
        "WDR36_431K"
    ],
    "WDR4": [
        "WDR4_373K",
        "WDR4_402K",
        "WDR4_385K"
    ],
    "WDR43": [
        "WDR43_391K"
    ],
    "WDR44": [
        "WDR44_261K"
    ],
    "WDR45B": [
        "WDR45B_266K"
    ],
    "WDR46": [
        "WDR46_567K"
    ],
    "WDR5": [
        "WDR5_6K"
    ],
    "WDR70": [
        "WDR70_514K"
    ],
    "WDR73": [
        "WDR73_66K"
    ],
    "WDR77": [
        "WDR77_3K"
    ],
    "WIZ": [
        "WIZ_987K",
        "WIZ_988K",
        "WIZ_1448K",
        "WIZ_1175K",
        "WIZ_1139K",
        "WIZ_1275K",
        "WIZ_1108K",
        "WIZ_1322K",
        "WIZ_964K",
        "WIZ_1356K",
        "WIZ_1534K",
        "WIZ_1138K",
        "WIZ_1382K"
    ],
    "WRNIP1": [
        "WRNIP1_633K",
        "WRNIP1_464K",
        "WRNIP1_627K"
    ],
    "XPC": [
        "XPC_374K",
        "XPC_50K"
    ],
    "XPO5": [
        "XPO5_1140K"
    ],
    "XPO7": [
        "XPO7_568K"
    ],
    "XRCC1": [
        "XRCC1_243K",
        "XRCC1_247K",
        "XRCC1_271K",
        "XRCC1_431K",
        "XRCC1_169K"
    ],
    "XRCC5": [
        "XRCC5_665K",
        "XRCC5_565K",
        "XRCC5_265K",
        "XRCC5_274K",
        "XRCC5_543K"
    ],
    "XRCC6": [
        "XRCC6_553K",
        "XRCC6_556K",
        "XRCC6_596K",
        "XRCC6_317K",
        "XRCC6_570K"
    ],
    "XRN2": [
        "XRN2_937K"
    ],
    "YAP1": [
        "YAP1_90K",
        "YAP1_321K"
    ],
    "YARS1": [
        "YARS1_356K",
        "YARS1_146K"
    ],
    "YBX1": [
        "YBX1_81K"
    ],
    "YME1L1": [
        "YME1L1_691K"
    ],
    "YTHDC1": [
        "YTHDC1_132K",
        "YTHDC1_565K",
        "YTHDC1_82K"
    ],
    "YWHAB": [
        "YWHAB_13K",
        "YWHAB_11K",
        "YWHAB_70K"
    ],
    "YWHAE": [
        "YWHAE_69K",
        "YWHAE_142K",
        "YWHAE_28K"
    ],
    "YWHAG": [
        "YWHAG_10K",
        "YWHAG_142K"
    ],
    "YWHAQ": [
        "YWHAQ_11K",
        "YWHAQ_9K",
        "YWHAQ_68K"
    ],
    "YWHAZ": [
        "YWHAZ_158K",
        "YWHAZ_122K",
        "YWHAZ_11K",
        "YWHAZ_85K",
        "YWHAZ_3K",
        "YWHAZ_9K",
        "YWHAZ_68K",
        "YWHAZ_138K"
    ],
    "YY1": [
        "YY1_183K",
        "YY1_203K",
        "YY1_208K",
        "YY1_409K",
        "YY1_301K"
    ],
    "ZBTB1": [
        "ZBTB1_200K"
    ],
    "ZBTB10": [
        "ZBTB10_240K"
    ],
    "ZBTB21": [
        "ZBTB21_273K"
    ],
    "ZBTB4": [
        "ZBTB4_675K"
    ],
    "ZBTB7A": [
        "ZBTB7A_396K"
    ],
    "ZBTB7B": [
        "ZBTB7B_212K",
        "ZBTB7B_360K",
        "ZBTB7B_206K"
    ],
    "ZC3H11A": [
        "ZC3H11A_300K",
        "ZC3H11A_659K",
        "ZC3H11A_665K"
    ],
    "ZC3H14": [
        "ZC3H14_304K",
        "ZC3H14_352K",
        "ZC3H14_139K"
    ],
    "ZC3H15": [
        "ZC3H15_44K"
    ],
    "ZC3H18": [
        "ZC3H18_780K",
        "ZC3H18_817K",
        "ZC3H18_823K",
        "ZC3H18_880K",
        "ZC3H18_528K",
        "ZC3H18_901K",
        "ZC3H18_908K",
        "ZC3H18_622K"
    ],
    "ZC3H4": [
        "ZC3H4_1193K"
    ],
    "ZC3H8": [
        "ZC3H8_61K"
    ],
    "ZC3HC1": [
        "ZC3HC1_31K"
    ],
    "ZFAND1": [
        "ZFAND1_113K"
    ],
    "ZFAND6": [
        "ZFAND6_204K"
    ],
    "ZFC3H1": [
        "ZFC3H1_687K"
    ],
    "ZFHX3": [
        "ZFHX3_1194K"
    ],
    "ZFP91": [
        "ZFP91_174K"
    ],
    "ZFPM2": [
        "ZFPM2_1037K",
        "ZFPM2_725K"
    ],
    "ZFR": [
        "ZFR_317K",
        "ZFR_501K"
    ],
    "ZHX2": [
        "ZHX2_73K",
        "ZHX2_188K"
    ],
    "ZHX3": [
        "ZHX3_188K"
    ],
    "ZMAT2": [
        "ZMAT2_15K",
        "ZMAT2_61K"
    ],
    "ZMYM2": [
        "ZMYM2_441K",
        "ZMYM2_104K",
        "ZMYM2_98K",
        "ZMYM2_297K",
        "ZMYM2_325K",
        "ZMYM2_829K",
        "ZMYM2_532K"
    ],
    "ZMYM3": [
        "ZMYM3_308K"
    ],
    "ZMYM4": [
        "ZMYM4_195K"
    ],
    "ZMYND8": [
        "ZMYND8_505K",
        "ZMYND8_1172K",
        "ZMYND8_1148K"
    ],
    "ZNF148": [
        "ZNF148_424K"
    ],
    "ZNF207": [
        "ZNF207_100K"
    ],
    "ZNF217": [
        "ZNF217_604K",
        "ZNF217_574K",
        "ZNF217_382K",
        "ZNF217_525K",
        "ZNF217_338K",
        "ZNF217_348K",
        "ZNF217_565K",
        "ZNF217_366K",
        "ZNF217_371K",
        "ZNF217_465K",
        "ZNF217_627K",
        "ZNF217_777K",
        "ZNF217_785K",
        "ZNF217_853K",
        "ZNF217_110K"
    ],
    "ZNF219": [
        "ZNF219_327K"
    ],
    "ZNF260": [
        "ZNF260_176K"
    ],
    "ZNF280C": [
        "ZNF280C_180K",
        "ZNF280C_174K",
        "ZNF280C_564K"
    ],
    "ZNF281": [
        "ZNF281_409K"
    ],
    "ZNF462": [
        "ZNF462_657K",
        "ZNF462_106K"
    ],
    "ZNF512B": [
        "ZNF512B_460K",
        "ZNF512B_286K",
        "ZNF512B_214K",
        "ZNF512B_196K",
        "ZNF512B_202K",
        "ZNF512B_262K",
        "ZNF512B_304K",
        "ZNF512B_226K",
        "ZNF512B_250K",
        "ZNF512B_208K",
        "ZNF512B_190K"
    ],
    "ZNF516": [
        "ZNF516_522K"
    ],
    "ZNF592": [
        "ZNF592_374K",
        "ZNF592_341K",
        "ZNF592_381K",
        "ZNF592_471K"
    ],
    "ZNF609": [
        "ZNF609_84K",
        "ZNF609_647K",
        "ZNF609_1100K"
    ],
    "ZNF638": [
        "ZNF638_1860K",
        "ZNF638_1477K",
        "ZNF638_1480K"
    ],
    "ZNF687": [
        "ZNF687_435K",
        "ZNF687_422K",
        "ZNF687_451K",
        "ZNF687_336K"
    ],
    "ZNF787": [
        "ZNF787_163K"
    ],
    "ZNF800": [
        "ZNF800_279K",
        "ZNF800_351K"
    ],
    "ZRANB2": [
        "ZRANB2_54K",
        "ZRANB2_59K",
        "ZRANB2_137K",
        "ZRANB2_46K",
        "ZRANB2_18K",
        "ZRANB2_95K"
    ],
    "ZYX": [
        "ZYX_272K",
        "ZYX_25K"
    ]
};

export default AllGeneListMatch;